import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { authFetch } from "../../auth";
import { usePermission } from "../Auth/PermissionContext";
import { PermissionKeys } from "../../permissions";
import { ActionModal } from "../Common/ActionModal";

const defaultAlarmFilters = {
  status: "all",
  level: "all",
  keyword: ""
};

const defaultLogFilters = {
  opType: "",
  keyword: ""
};

const defaultCommandTaskFilters = {
  status: "all",
  deviceNo: "",
  commandType: "all"
};

const defaultCommandDeviceFilters = {
  online: "all",
  customerId: "all",
  keyword: ""
};

const commandDevicePageSize = 20;
const commandTaskPageSize = 20;

const defaultFirmwareTaskFilters = {
  status: "all",
  deviceNo: "",
  firmwareVersion: ""
};

const defaultServiceLogFilters = {
  moduleName: "",
  status: "all"
};

const gggOperationLogTypes = [
  "GGG_SERVICE_STATUS_CHECK",
  "GGG_SYSTEM_ALARM_ACK",
  "GGG_SYSTEM_ALARM_RULE_UPDATE",
  "GGG_PROGRAM_CONFIG_UPDATE",
  "GGG_DEVICE_COMMAND_CREATE",
  "GGG_DEVICE_COMMAND_DIRECT_CREATE",
  "GGG_DEVICE_COMMAND_DIRECT_SEND",
  "GGG_DEVICE_COMMAND_DIRECT_SEND_FAILED",
  "GGG_DEVICE_COMMAND_DIRECT_RESPONSE",
  "GGG_DEVICE_COMMAND_DIRECT_RESPONSE_TIMEOUT",
  "GGG_DEVICE_COMMAND_OFFLINE_QUEUE",
  "GGG_DEVICE_COMMAND_SEND",
  "GGG_DEVICE_COMMAND_SEND_FAILED",
  "GGG_DEVICE_COMMAND_CANCEL",
  "GGG_DEVICE_COMMAND_DISPATCH_CHECK",
  "GGG_DEVICE_PARAMETER_READ_CREATE",
  "GGG_DEVICE_PARAMETER_WRITE_CREATE",
  "GGG_FIRMWARE_PACKAGE_REGISTER",
  "GGG_FIRMWARE_PACKAGE_DISABLE",
  "GGG_FIRMWARE_UPGRADE_CREATE",
  "GGG_FIRMWARE_UPGRADE_DISPATCH_CHECK",
  "GGG_FIRMWARE_UPGRADE_CANCEL"
];

const commandPayloadPresets = {
  read_device_info: "{\"protocolVersion\":2}",
  read_parameters_work: "{\"protocolVersion\":2,\"parameterGroup\":\"work\"}",
  read_parameters_network: "{\"protocolVersion\":2,\"parameterGroup\":\"network\"}",
  set_parameters_work: "{\"protocolVersion\":2,\"parameterGroup\":\"work\",\"sampleCycle\":10,\"uploadCycle\":60,\"com1Baudrate\":9600,\"com1Use\":0,\"workButton\":0,\"barcodeDataType\":0}",
  set_parameters_network: "{\"protocolVersion\":2,\"parameterGroup\":\"network\",\"valid1\":1,\"apn1\":\"\",\"userName1\":\"\",\"password1\":\"\",\"dialnum1\":\"\",\"dnsIp1\":\"0.0.0.0\",\"domainName1\":\"\",\"serverIp1\":\"0.0.0.0\",\"serverPort1\":\"\",\"deviceNo1\":\"\"}",
  clear_alarm: "{\"protocolVersion\":2}",
  reset_gps_module: "{\"protocolVersion\":2}"
};

const commandActionOptions = [
  { key: "read_device_info", label: "设备信息（读）", commandType: "read_device_info", presetKey: "read_device_info", riskLevel: "low", kind: "read" },
  { key: "read_work", label: "工作参数（读）", commandType: "read_parameters", presetKey: "read_parameters_work", riskLevel: "low", kind: "read" },
  { key: "write_work", label: "工作参数（写）", commandType: "set_parameters", presetKey: "set_parameters_work", riskLevel: "high", kind: "write" },
  { key: "read_network", label: "网络参数（读）", commandType: "read_parameters", presetKey: "read_parameters_network", riskLevel: "low", kind: "read" },
  { key: "write_network", label: "网络参数（写）", commandType: "set_parameters", presetKey: "set_parameters_network", riskLevel: "high", kind: "write" },
  { key: "clear_alarm", label: "清除报警", commandType: "clear_alarm", presetKey: "clear_alarm", riskLevel: "medium", kind: "action" },
  { key: "reset_gps_module", label: "重启 GPS 模块", commandType: "reset_gps_module", presetKey: "reset_gps_module", riskLevel: "critical", kind: "action" }
];

const commandWriteDefaults = {
  write_work: {
    protocolVersion: 2,
    parameterGroup: "work",
    sampleCycle: 10,
    uploadCycle: 60,
    com1Baudrate: 9600,
    com1Use: 0,
    workButton: 0,
    barcodeDataType: 0
  },
  write_network: {
    protocolVersion: 2,
    parameterGroup: "network",
    valid1: 1,
    apn1: "",
    userName1: "",
    password1: "",
    dialnum1: "",
    dnsIp1: "0.0.0.0",
    domainName1: "",
    serverIp1: "0.0.0.0",
    serverPort1: "",
    deviceNo1: "",
    valid2: 0,
    apn2: "",
    userName2: "",
    password2: "",
    dialnum2: "",
    dnsIp2: "0.0.0.0",
    domainName2: "",
    serverIp2: "0.0.0.0",
    serverPort2: "",
    deviceNo2: ""
  }
};

const operationLogSectionLabels = {
  target: "对象",
  before: "变更前",
  after: "变更后",
  extra: "扩展"
};

const operationLogFieldLabels = {
  module: "模块",
  action: "动作",
  Id: "ID",
  id: "ID",
  DeviceNo: "设备",
  deviceNo: "设备",
  CommandType: "指令",
  FirmwareVersion: "固件",
  Status: "状态",
  status: "状态",
  CheckStatus: "检查",
  ExecutorEnabled: "执行器",
  UpgradeEnabled: "升级开关",
  DeviceOnline: "在线",
  CanDispatch: "可下发",
  PackageRegistered: "固件包",
  AlarmKey: "报警",
  Code: "编码",
  AckedBy: "确认人",
  AckRemark: "备注",
  Remark: "备注",
  TotalCount: "总数",
  AbnormalCount: "异常",
  CheckBatchId: "批次",
  PackageName: "包名",
  PackageFileName: "文件名",
  PackageChecksum: "校验值",
  PayloadJson: "载荷",
  Blockers: "阻断",
  Warnings: "提醒"
};

const gggManagerSections = [
  { key: "overview", label: "总览", to: "/ggg-manager", permission: PermissionKeys.GggManagerView },
  { key: "services", label: "服务状态", to: "/ggg-manager/services", permission: PermissionKeys.GggServiceView },
  { key: "clients", label: "客户端", to: "/ggg-manager/clients", permission: PermissionKeys.GggClientView },
  { key: "commands", label: "设备指令", to: "/ggg-manager/commands", permission: PermissionKeys.GggManagerView },
  { key: "firmware", label: "固件升级", to: "/ggg-manager/firmware", permission: PermissionKeys.GggFirmwareUpgrade },
  { key: "alarms", label: "系统报警", to: "/ggg-manager/alarms", permission: PermissionKeys.GggAlarmView },
  { key: "config", label: "规则配置", to: "/ggg-manager/config", permission: PermissionKeys.GggManagerView },
  { key: "logs", label: "操作审计", to: "/ggg-manager/logs", permission: PermissionKeys.GggManagerView }
];

export function GGGManagerPage({ section = "overview" }) {
  const { can } = usePermission();
  const activeSection = gggManagerSections.some((item) => item.key === section) ? section : "overview";
  const canManagerView = can(PermissionKeys.GggManagerView);
  const canServiceView = can(PermissionKeys.GggServiceView);
  const canServiceManage = can(PermissionKeys.GggServiceManage);
  const canClientView = can(PermissionKeys.GggClientView);
  const canAlarmView = can(PermissionKeys.GggAlarmView);
  const canAlarmConfig = can(PermissionKeys.GggAlarmConfig);
  const canDeviceCommand = can(PermissionKeys.GggDeviceCommand);
  const canDeviceParameter = can(PermissionKeys.GggDeviceParameter);
  const canDeviceOps = canDeviceCommand || canDeviceParameter;
  const canFirmwareUpgrade = can(PermissionKeys.GggFirmwareUpgrade);
  const canProgramConfig = can(PermissionKeys.GggProgramConfig);
  const showOverview = activeSection === "overview";
  const showServices = activeSection === "services";
  const showClients = activeSection === "clients";
  const showCommands = activeSection === "commands";
  const showFirmware = activeSection === "firmware";
  const showAlarms = activeSection === "alarms";
  const showConfig = activeSection === "config";
  const showLogs = activeSection === "logs";

  const [overview, setOverview] = useState(null);
  const [systemAlarms, setSystemAlarms] = useState([]);
  const [systemAlarmRules, setSystemAlarmRules] = useState([]);
  const [programConfigs, setProgramConfigs] = useState([]);
  const [commandTemplates, setCommandTemplates] = useState([]);
  const [commandTasks, setCommandTasks] = useState([]);
  const [commandDevices, setCommandDevices] = useState([]);
  const [commandCustomerOptions, setCommandCustomerOptions] = useState([]);
  const [firmwareTasks, setFirmwareTasks] = useState([]);
  const [firmwarePackages, setFirmwarePackages] = useState([]);
  const [clientOnlineItems, setClientOnlineItems] = useState([]);
  const [clientConnectionLogs, setClientConnectionLogs] = useState([]);
  const [clientSourceNote, setClientSourceNote] = useState("");
  const [operationLogs, setOperationLogs] = useState([]);
  const [serviceLogs, setServiceLogs] = useState([]);
  const [serviceStatusCheck, setServiceStatusCheck] = useState(null);
  const [alarmTreatmentRecordDetail, setAlarmTreatmentRecordDetail] = useState(null);
  const [alarmFilters, setAlarmFilters] = useState(defaultAlarmFilters);
  const [logFilters, setLogFilters] = useState(defaultLogFilters);
  const [commandTaskFilters, setCommandTaskFilters] = useState(defaultCommandTaskFilters);
  const [commandDeviceFilters, setCommandDeviceFilters] = useState(defaultCommandDeviceFilters);
  const [commandActiveTab, setCommandActiveTab] = useState("devices");
  const [commandDevicePage, setCommandDevicePage] = useState(1);
  const [commandDeviceTotal, setCommandDeviceTotal] = useState(0);
  const [commandTaskPage, setCommandTaskPage] = useState(1);
  const [commandTaskTotal, setCommandTaskTotal] = useState(0);
  const [firmwareTaskFilters, setFirmwareTaskFilters] = useState(defaultFirmwareTaskFilters);
  const [serviceLogFilters, setServiceLogFilters] = useState(defaultServiceLogFilters);
  const alarmFiltersRef = useRef(defaultAlarmFilters);
  const logFiltersRef = useRef(defaultLogFilters);
  const commandTaskFiltersRef = useRef(defaultCommandTaskFilters);
  const commandDeviceFiltersRef = useRef(defaultCommandDeviceFilters);
  const commandDevicePageRef = useRef(1);
  const commandTaskPageRef = useRef(1);
  const firmwareTaskFiltersRef = useRef(defaultFirmwareTaskFilters);
  const serviceLogFiltersRef = useRef(defaultServiceLogFilters);
  const [loading, setLoading] = useState(false);
  const [alarmLoading, setAlarmLoading] = useState(false);
  const [ruleLoading, setRuleLoading] = useState(false);
  const [configLoading, setConfigLoading] = useState(false);
  const [commandLoading, setCommandLoading] = useState(false);
  const [firmwareLoading, setFirmwareLoading] = useState(false);
  const [firmwarePackageLoading, setFirmwarePackageLoading] = useState(false);
  const [clientLoading, setClientLoading] = useState(false);
  const [logLoading, setLogLoading] = useState(false);
  const [serviceLogLoading, setServiceLogLoading] = useState(false);
  const [loadingAlarmTreatmentId, setLoadingAlarmTreatmentId] = useState("");
  const [sendingCommand, setSendingCommand] = useState(false);
  const [creatingFirmwareTask, setCreatingFirmwareTask] = useState(false);
  const [creatingFirmwarePackage, setCreatingFirmwarePackage] = useState(false);
  const [acknowledgingId, setAcknowledgingId] = useState("");
  const [updatingRuleKey, setUpdatingRuleKey] = useState("");
  const [updatingConfigKey, setUpdatingConfigKey] = useState("");
  const [cancellingCommandId, setCancellingCommandId] = useState("");
  const [checkingCommandId, setCheckingCommandId] = useState("");
  const [checkingServices, setCheckingServices] = useState(false);
  const [cancellingFirmwareId, setCancellingFirmwareId] = useState("");
  const [checkingFirmwareId, setCheckingFirmwareId] = useState("");
  const [disablingFirmwarePackageId, setDisablingFirmwarePackageId] = useState("");
  const [error, setError] = useState("");
  const [alarmError, setAlarmError] = useState("");
  const [ruleError, setRuleError] = useState("");
  const [configError, setConfigError] = useState("");
  const [commandError, setCommandError] = useState("");
  const [firmwareError, setFirmwareError] = useState("");
  const [firmwarePackageError, setFirmwarePackageError] = useState("");
  const [clientError, setClientError] = useState("");
  const [logError, setLogError] = useState("");
  const [serviceLogError, setServiceLogError] = useState("");
  const [commandDispatchCheck, setCommandDispatchCheck] = useState(null);
  const [commandSendResult, setCommandSendResult] = useState(null);
  const [selectedCommandDevice, setSelectedCommandDevice] = useState(null);
  const [commandModal, setCommandModal] = useState({ open: false, device: null, action: null, result: null });
  const [commandTaskDetail, setCommandTaskDetail] = useState(null);
  const [loadingCommandDetailId, setLoadingCommandDetailId] = useState("");
  const [firmwareDispatchCheck, setFirmwareDispatchCheck] = useState(null);
  const [firmwareTaskDetail, setFirmwareTaskDetail] = useState(null);
  const [loadingFirmwareDetailId, setLoadingFirmwareDetailId] = useState("");
  const [ackAlarmModal, setAckAlarmModal] = useState({ open: false, row: null });

  const [firmwareForm, setFirmwareForm] = useState({
    deviceNo: "",
    firmwareVersion: "",
    packageName: "",
    packageFileName: "",
    packageChecksum: "",
    remark: ""
  });
  const [firmwarePackageForm, setFirmwarePackageForm] = useState({
    firmwareVersion: "",
    packageName: "",
    packageFileName: "",
    packageChecksum: "",
    remark: ""
  });

  const loadOverview = useCallback(async () => {
    try {
      const res = await authFetch("/api/ggg-manager/overview");
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "GGGManager 总览加载失败");
      }

      const data = await res.json();
      setOverview(data);
    } catch (err) {
      setError(err?.message || "GGGManager 总览加载失败");
      setOverview(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const loadSystemAlarms = useCallback(async (filtersOverride) => {
    const filters = filtersOverride || alarmFiltersRef.current;
    const params = new URLSearchParams();
    if (filters.status && filters.status !== "all") params.set("status", filters.status);
    if (filters.level && filters.level !== "all") params.set("level", filters.level);
    if (filters.keyword?.trim()) params.set("keyword", filters.keyword.trim());
    const query = params.toString();

    setAlarmLoading(true);

    try {
      const res = await authFetch(`/api/ggg-manager/system-alarms${query ? `?${query}` : ""}`);
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "系统报警加载失败");
      }

      const data = await res.json();
      setSystemAlarms(Array.isArray(data?.items) ? data.items : []);
    } catch (err) {
      setAlarmError(err?.message || "系统报警加载失败");
      setSystemAlarms([]);
    } finally {
      setAlarmLoading(false);
    }
  }, []);

  const loadSystemAlarmRules = useCallback(async () => {
    setRuleLoading(true);

    try {
      const res = await authFetch("/api/ggg-manager/system-alarm-rules");
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "系统报警规则加载失败");
      }

      const data = await res.json();
      setSystemAlarmRules(Array.isArray(data?.items) ? data.items : []);
    } catch (err) {
      setRuleError(err?.message || "系统报警规则加载失败");
      setSystemAlarmRules([]);
    } finally {
      setRuleLoading(false);
    }
  }, []);

  const loadProgramConfigs = useCallback(async () => {
    setConfigLoading(true);

    try {
      const res = await authFetch("/api/ggg-manager/program-config");
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "程序配置加载失败");
      }

      const data = await res.json();
      setProgramConfigs(Array.isArray(data?.items) ? data.items : []);
    } catch (err) {
      setConfigError(err?.message || "程序配置加载失败");
      setProgramConfigs([]);
    } finally {
      setConfigLoading(false);
    }
  }, []);

  const loadCommandData = useCallback(async (filtersOverride, options = {}) => {
    const filters = filtersOverride || commandTaskFiltersRef.current;
    const taskPage = options.taskPage || commandTaskPageRef.current;
    const devicePage = options.devicePage || commandDevicePageRef.current;
    const params = new URLSearchParams({
      page: String(taskPage),
      pageSize: String(commandTaskPageSize)
    });
    if (filters.status && filters.status !== "all") params.set("status", filters.status);
    if (filters.deviceNo?.trim()) params.set("deviceNo", filters.deviceNo.trim());
    if (filters.commandType && filters.commandType !== "all") params.set("commandType", filters.commandType);
    const deviceFilters = commandDeviceFiltersRef.current;
    const deviceParams = new URLSearchParams({
      page: String(devicePage),
      pageSize: String(commandDevicePageSize),
      online: deviceFilters.online || "all"
    });
    if (deviceFilters.keyword?.trim()) deviceParams.set("keyword", deviceFilters.keyword.trim());
    if (deviceFilters.customerId && deviceFilters.customerId !== "all") deviceParams.set("customerId", deviceFilters.customerId);

    setCommandLoading(true);

    try {
      const [templatesRes, tasksRes, devicesRes, customersRes] = await Promise.all([
        authFetch("/api/ggg-manager/device-command-templates"),
        authFetch(`/api/ggg-manager/device-command-tasks?${params.toString()}`),
        authFetch(`/api/ggg-manager/device-command-targets?${deviceParams.toString()}`),
        authFetch("/api/ggg-manager/device-command-customers")
      ]);

      if (!templatesRes.ok) {
        const text = await templatesRes.text();
        throw new Error(text || "设备指令模板加载失败");
      }
      if (!tasksRes.ok) {
        const text = await tasksRes.text();
        throw new Error(text || "设备指令任务加载失败");
      }
      if (!devicesRes.ok) {
        const text = await devicesRes.text();
        throw new Error(text || "设备列表加载失败");
      }
      if (!customersRes.ok) {
        const text = await customersRes.text();
        throw new Error(text || "客户列表加载失败");
      }

      const templatesData = await templatesRes.json();
      const tasksData = await tasksRes.json();
      const devicesData = await devicesRes.json();
      const customersData = await customersRes.json();
      const nextDevices = Array.isArray(devicesData?.items) ? devicesData.items : [];
      setCommandTemplates(Array.isArray(templatesData?.items) ? templatesData.items : []);
      setCommandTasks(Array.isArray(tasksData?.items) ? tasksData.items : []);
      setCommandTaskTotal(Number(tasksData?.total || 0));
      setCommandDevices(nextDevices);
      setCommandDeviceTotal(Number(devicesData?.total || 0));
      setCommandCustomerOptions(Array.isArray(customersData?.items) ? customersData.items : []);
      setSelectedCommandDevice((current) => {
        if (!current) return nextDevices[0] || null;
        return nextDevices.find((item) => item.deviceNo === current.deviceNo) || current;
      });
    } catch (err) {
      setCommandError(err?.message || "设备指令任务加载失败");
      setCommandTemplates([]);
      setCommandTasks([]);
      setCommandTaskTotal(0);
      setCommandDevices([]);
      setCommandDeviceTotal(0);
      setCommandCustomerOptions([]);
    } finally {
      setCommandLoading(false);
    }
  }, []);
  const loadFirmwareTasks = useCallback(async (filtersOverride) => {
    const filters = filtersOverride || firmwareTaskFiltersRef.current;
    const params = new URLSearchParams({
      page: "1",
      pageSize: "20"
    });
    if (filters.status && filters.status !== "all") params.set("status", filters.status);
    if (filters.deviceNo?.trim()) params.set("deviceNo", filters.deviceNo.trim());
    if (filters.firmwareVersion?.trim()) params.set("firmwareVersion", filters.firmwareVersion.trim());

    setFirmwareLoading(true);

    try {
      const res = await authFetch(`/api/ggg-manager/firmware-upgrade-tasks?${params.toString()}`);
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "固件升级任务加载失败");
      }

      const data = await res.json();
      setFirmwareTasks(Array.isArray(data?.items) ? data.items : []);
    } catch (err) {
      setFirmwareError(err?.message || "固件升级任务加载失败");
      setFirmwareTasks([]);
    } finally {
      setFirmwareLoading(false);
    }
  }, []);

  const loadFirmwarePackages = useCallback(async () => {
    setFirmwarePackageLoading(true);

    try {
      const res = await authFetch("/api/ggg-manager/firmware-packages?page=1&pageSize=20");
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "固件包加载失败");
      }

      const data = await res.json();
      setFirmwarePackages(Array.isArray(data?.items) ? data.items : []);
    } catch (err) {
      setFirmwarePackageError(err?.message || "固件包加载失败");
      setFirmwarePackages([]);
    } finally {
      setFirmwarePackageLoading(false);
    }
  }, []);

  const loadClientMonitoring = useCallback(async () => {
    setClientLoading(true);

    try {
      const [onlineRes, logsRes] = await Promise.all([
        authFetch("/api/ggg-manager/clients/online?page=1&pageSize=20&lookbackHours=24"),
        authFetch("/api/ggg-manager/clients/logs?page=1&pageSize=20")
      ]);

      if (!onlineRes.ok) {
        const text = await onlineRes.text();
        throw new Error(text || "客户端在线状态加载失败");
      }
      if (!logsRes.ok) {
        const text = await logsRes.text();
        throw new Error(text || "客户端连接日志加载失败");
      }

      const onlineData = await onlineRes.json();
      const logsData = await logsRes.json();
      setClientOnlineItems(Array.isArray(onlineData?.items) ? onlineData.items : []);
      setClientConnectionLogs(Array.isArray(logsData?.items) ? logsData.items : []);
      setClientSourceNote(onlineData?.sourceNote || "");
    } catch (err) {
      setClientError(err?.message || "客户端监控加载失败");
      setClientOnlineItems([]);
      setClientConnectionLogs([]);
      setClientSourceNote("");
    } finally {
      setClientLoading(false);
    }
  }, []);

  const loadOperationLogs = useCallback(async (filtersOverride) => {
    const filters = filtersOverride || logFiltersRef.current;
    const params = new URLSearchParams({
      page: "1",
      pageSize: "20"
    });
    if (filters.opType?.trim()) params.set("opType", filters.opType.trim());
    if (filters.keyword?.trim()) params.set("keyword", filters.keyword.trim());

    setLogLoading(true);

    try {
      const res = await authFetch(`/api/ggg-manager/operation-logs?${params.toString()}`);
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "操作审计日志加载失败");
      }

      const data = await res.json();
      setOperationLogs(Array.isArray(data?.items) ? data.items : []);
    } catch (err) {
      setLogError(err?.message || "操作审计日志加载失败");
      setOperationLogs([]);
    } finally {
      setLogLoading(false);
    }
  }, []);

  const loadServiceLogs = useCallback(async (filtersOverride) => {
    const filters = filtersOverride || serviceLogFiltersRef.current;
    const params = new URLSearchParams({
      page: "1",
      pageSize: "20"
    });
    if (filters.moduleName?.trim()) params.set("moduleName", filters.moduleName.trim());
    if (filters.status && filters.status !== "all") params.set("status", filters.status);

    setServiceLogLoading(true);

    try {
      const res = await authFetch(`/api/ggg-manager/status/service-logs?${params.toString()}`);
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "服务状态检查日志加载失败");
      }

      const data = await res.json();
      setServiceLogs(Array.isArray(data?.items) ? data.items : []);
    } catch (err) {
      setServiceLogError(err?.message || "服务状态检查日志加载失败");
      setServiceLogs([]);
    } finally {
      setServiceLogLoading(false);
    }
  }, []);

  const loadPageData = useCallback(async () => {
    setLoading(canManagerView && (showOverview || showServices));
    setAlarmLoading(canAlarmView && showAlarms);
    setRuleLoading(canAlarmConfig && showConfig);
    setConfigLoading(canProgramConfig && showConfig);
    setCommandLoading(canDeviceOps && showCommands);
    setFirmwareLoading(canFirmwareUpgrade && showFirmware);
    setFirmwarePackageLoading(canFirmwareUpgrade && showFirmware);
    setClientLoading(canClientView && showClients);
    setLogLoading(canManagerView && showLogs);
    setServiceLogLoading(canServiceView && showServices);
    setError("");
    setAlarmError("");
    setRuleError("");
    setConfigError("");
    setCommandError("");
    setFirmwareError("");
    setFirmwarePackageError("");
    setClientError("");
    setLogError("");
    setServiceLogError("");

    const tasks = [];
    if (canManagerView && (showOverview || showServices)) tasks.push(loadOverview());
    if (canServiceView && showServices) tasks.push(loadServiceLogs());
    if (canAlarmView && showAlarms) tasks.push(loadSystemAlarms());
    if (canAlarmConfig && showConfig) tasks.push(loadSystemAlarmRules());
    if (canProgramConfig && showConfig) tasks.push(loadProgramConfigs());
    if (canDeviceOps && showCommands) tasks.push(loadCommandData());
    if (canFirmwareUpgrade && showFirmware) tasks.push(loadFirmwareTasks(), loadFirmwarePackages());
    if (canClientView && showClients) tasks.push(loadClientMonitoring());
    if (canManagerView && showLogs) tasks.push(loadOperationLogs());

    await Promise.all(tasks);
  }, [
    canManagerView,
    canServiceView,
    canAlarmView,
    canAlarmConfig,
    canProgramConfig,
    canDeviceOps,
    canFirmwareUpgrade,
    canClientView,
    showOverview,
    showServices,
    showClients,
    showCommands,
    showFirmware,
    showAlarms,
    showConfig,
    showLogs,
    loadOverview,
    loadSystemAlarms,
    loadSystemAlarmRules,
    loadProgramConfigs,
    loadCommandData,
    loadFirmwareTasks,
    loadFirmwarePackages,
    loadClientMonitoring,
    loadOperationLogs,
    loadServiceLogs
  ]);

  useEffect(() => {
    loadPageData();
  }, [loadPageData]);

  async function handleCheckServiceStatuses() {
    if (!canServiceManage) {
      setError("当前账号无服务主动检查权限。");
      return;
    }

    setCheckingServices(true);
    setError("");
    setServiceStatusCheck(null);

    try {
      const res = await authFetch("/api/ggg-manager/status/services/check", {
        method: "POST"
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "服务主动检查失败");
      }

      const data = await res.json();
      setServiceStatusCheck(data);
      await Promise.all([loadOverview(), loadOperationLogs(), loadServiceLogs()]);
    } catch (err) {
      setError(err?.message || "服务主动检查失败");
    } finally {
      setCheckingServices(false);
    }
  }

  function updateAlarmFilter(field, value) {
    setAlarmFilters((current) => {
      const next = { ...current, [field]: value };
      alarmFiltersRef.current = next;
      return next;
    });
  }

  function updateLogFilter(field, value) {
    setLogFilters((current) => {
      const next = { ...current, [field]: value };
      logFiltersRef.current = next;
      return next;
    });
  }

  function updateCommandTaskFilter(field, value) {
    setCommandTaskFilters((current) => {
      const next = { ...current, [field]: value };
      commandTaskFiltersRef.current = next;
      return next;
    });
  }

  function updateCommandDeviceFilter(field, value) {
    setCommandDeviceFilters((current) => {
      const next = { ...current, [field]: value };
      commandDeviceFiltersRef.current = next;
      return next;
    });
  }

  function selectCommandDevice(device) {
    setSelectedCommandDevice(device);
    setCommandDispatchCheck(null);
    setCommandSendResult(null);
  }

  function updateFirmwareTaskFilter(field, value) {
    setFirmwareTaskFilters((current) => {
      const next = { ...current, [field]: value };
      firmwareTaskFiltersRef.current = next;
      return next;
    });
  }

  function updateServiceLogFilter(field, value) {
    setServiceLogFilters((current) => {
      const next = { ...current, [field]: value };
      serviceLogFiltersRef.current = next;
      return next;
    });
  }

  async function handleApplyAlarmFilters(event) {
    event.preventDefault();
    alarmFiltersRef.current = alarmFilters;
    setAlarmError("");
    await loadSystemAlarms(alarmFilters);
  }

  async function handleOnlyActiveAlarms() {
    const next = { ...alarmFilters, status: "active" };
    setAlarmFilters(next);
    alarmFiltersRef.current = next;
    setAlarmError("");
    await loadSystemAlarms(next);
  }

  async function handleClearAlarmFilters() {
    const next = { ...defaultAlarmFilters };
    setAlarmFilters(next);
    alarmFiltersRef.current = next;
    setAlarmError("");
    await loadSystemAlarms(next);
  }

  async function handleApplyLogFilters(event) {
    event.preventDefault();
    logFiltersRef.current = logFilters;
    setLogError("");
    await loadOperationLogs(logFilters);
  }

  async function handleClearLogFilters() {
    const next = { ...defaultLogFilters };
    setLogFilters(next);
    logFiltersRef.current = next;
    setLogError("");
    await loadOperationLogs(next);
  }

  async function handleApplyCommandTaskFilters(event) {
    event.preventDefault();
    commandTaskFiltersRef.current = commandTaskFilters;
    commandTaskPageRef.current = 1;
    setCommandTaskPage(1);
    setCommandError("");
    await loadCommandData(commandTaskFilters, { taskPage: 1 });
  }

  async function handleClearCommandTaskFilters() {
    const next = { ...defaultCommandTaskFilters };
    setCommandTaskFilters(next);
    commandTaskFiltersRef.current = next;
    commandTaskPageRef.current = 1;
    setCommandTaskPage(1);
    setCommandError("");
    await loadCommandData(next, { taskPage: 1 });
  }

  async function handleOnlyQueuedCommandTasks() {
    const next = { ...commandTaskFilters, status: "queued" };
    setCommandTaskFilters(next);
    commandTaskFiltersRef.current = next;
    commandTaskPageRef.current = 1;
    setCommandTaskPage(1);
    setCommandError("");
    await loadCommandData(next, { taskPage: 1 });
  }

  async function handleApplyCommandDeviceFilters(event) {
    event.preventDefault();
    commandDeviceFiltersRef.current = commandDeviceFilters;
    commandDevicePageRef.current = 1;
    setCommandDevicePage(1);
    setCommandError("");
    await loadCommandData(undefined, { devicePage: 1 });
  }

  async function handleClearCommandDeviceFilters() {
    const next = { ...defaultCommandDeviceFilters };
    setCommandDeviceFilters(next);
    commandDeviceFiltersRef.current = next;
    commandDevicePageRef.current = 1;
    setCommandDevicePage(1);
    setCommandError("");
    await loadCommandData(undefined, { devicePage: 1 });
  }

  async function changeCommandDevicePage(nextPage) {
    const safePage = Math.max(1, nextPage);
    commandDevicePageRef.current = safePage;
    setCommandDevicePage(safePage);
    setCommandError("");
    await loadCommandData(undefined, { devicePage: safePage });
  }

  async function changeCommandTaskPage(nextPage) {
    const safePage = Math.max(1, nextPage);
    commandTaskPageRef.current = safePage;
    setCommandTaskPage(safePage);
    setCommandError("");
    await loadCommandData(undefined, { taskPage: safePage });
  }
  async function handleApplyFirmwareTaskFilters(event) {
    event.preventDefault();
    firmwareTaskFiltersRef.current = firmwareTaskFilters;
    setFirmwareError("");
    await loadFirmwareTasks(firmwareTaskFilters);
  }

  async function handleClearFirmwareTaskFilters() {
    const next = { ...defaultFirmwareTaskFilters };
    setFirmwareTaskFilters(next);
    firmwareTaskFiltersRef.current = next;
    setFirmwareError("");
    await loadFirmwareTasks(next);
  }

  async function handleOnlyQueuedFirmwareTasks() {
    const next = { ...firmwareTaskFilters, status: "queued" };
    setFirmwareTaskFilters(next);
    firmwareTaskFiltersRef.current = next;
    setFirmwareError("");
    await loadFirmwareTasks(next);
  }

  async function handleApplyServiceLogFilters(event) {
    event.preventDefault();
    serviceLogFiltersRef.current = serviceLogFilters;
    setServiceLogError("");
    await loadServiceLogs(serviceLogFilters);
  }

  async function handleClearServiceLogFilters() {
    const next = { ...defaultServiceLogFilters };
    setServiceLogFilters(next);
    serviceLogFiltersRef.current = next;
    setServiceLogError("");
    await loadServiceLogs(next);
  }

  function openAckAlarmModal(item) {
    if (!canAlarmView) {
      setAlarmError("当前账号无系统报警查看/确认权限。");
      return;
    }

    setAlarmError("");
    setAckAlarmModal({ open: true, row: item });
  }

  async function submitAckAlarm(form) {
    const item = ackAlarmModal.row;
    if (!item) return;

    const id = item.eventId || item.id;
    if (!id) return;

    setAcknowledgingId(String(id));
    setAlarmError("");

    try {
      const res = await authFetch(`/api/ggg-manager/system-alarms/${encodeURIComponent(id)}/ack`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ remark: form?.remark?.trim() || null })
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "系统报警确认失败");
      }

      setAckAlarmModal({ open: false, row: null });
      setAlarmTreatmentRecordDetail(null);
      await loadSystemAlarms();
    } catch (err) {
      setAlarmError(err?.message || "系统报警确认失败");
    } finally {
      setAcknowledgingId("");
    }
  }

  async function handleLoadAlarmTreatmentRecords(item) {
    if (!canAlarmView) {
      setAlarmError("当前账号无系统报警处理记录查看权限。");
      return;
    }

    const id = item.eventId || item.id;
    if (!id) return;

    setLoadingAlarmTreatmentId(String(id));
    setAlarmError("");

    try {
      const res = await authFetch(`/api/ggg-manager/system-alarms/${encodeURIComponent(id)}/treatment-records`);
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "系统报警处理记录加载失败");
      }

      setAlarmTreatmentRecordDetail(await res.json());
    } catch (err) {
      setAlarmError(err?.message || "系统报警处理记录加载失败");
      setAlarmTreatmentRecordDetail(null);
    } finally {
      setLoadingAlarmTreatmentId("");
    }
  }

  async function handleUpdateAlarmRule(rule, changes) {
    if (!canAlarmConfig) {
      setRuleError("当前账号无系统报警规则配置权限。");
      return;
    }

    const ruleKey = rule.ruleKey;
    if (!ruleKey) return;

    setUpdatingRuleKey(ruleKey);
    setRuleError("");

    try {
      const res = await authFetch(`/api/ggg-manager/system-alarm-rules/${encodeURIComponent(ruleKey)}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          isEnabled: changes.isEnabled ?? rule.isEnabled,
          level: changes.level ?? rule.level
        })
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "系统报警规则更新失败");
      }

      await Promise.all([loadSystemAlarmRules(), loadSystemAlarms()]);
    } catch (err) {
      setRuleError(err?.message || "系统报警规则更新失败");
    } finally {
      setUpdatingRuleKey("");
    }
  }

  async function handleUpdateProgramConfig(config, nextValue) {
    if (!canProgramConfig) {
      setConfigError("当前账号无程序配置权限。");
      return;
    }

    const configKey = config.configKey;
    if (!configKey) return;

    setUpdatingConfigKey(configKey);
    setConfigError("");

    try {
      const res = await authFetch(`/api/ggg-manager/program-config/${encodeURIComponent(configKey)}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ configValue: nextValue })
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "程序配置更新失败");
      }

      await Promise.all([loadProgramConfigs(), loadOverview()]);
    } catch (err) {
      setConfigError(err?.message || "程序配置更新失败");
    } finally {
      setUpdatingConfigKey("");
    }
  }

  async function handleCancelCommandTask(item) {
    if (!canOperateCommandTask(item)) {
      setCommandError("当前账号无该任务类型的取消权限。");
      return;
    }

    const id = item.taskId || item.id;
    if (!id) return;

    setCancellingCommandId(String(id));
    setCommandError("");
    setCommandDispatchCheck(null);
    setCommandTaskDetail(null);

    try {
      const res = await authFetch(`/api/ggg-manager/device-command-tasks/${encodeURIComponent(id)}/cancel`, {
        method: "POST"
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "设备指令任务取消失败");
      }

      await loadCommandData();
    } catch (err) {
      setCommandError(err?.message || "设备指令任务取消失败");
    } finally {
      setCancellingCommandId("");
    }
  }

  async function handleCheckCommandDispatch(item) {
    if (!canOperateCommandTask(item)) {
      setCommandError("当前账号无该任务类型的发送检查权限。");
      return;
    }

    const id = item.taskId || item.id;
    if (!id) return;

    setCheckingCommandId(String(id));
    setCommandError("");
    setCommandDispatchCheck(null);

    try {
      const res = await authFetch(`/api/ggg-manager/device-command-tasks/${encodeURIComponent(id)}/dispatch-check`, {
        method: "POST"
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "设备指令发送检查失败");
      }

      const data = await res.json();
      setCommandDispatchCheck(data);
      await loadOperationLogs();
    } catch (err) {
      setCommandError(err?.message || "设备指令发送检查失败");
    } finally {
      setCheckingCommandId("");
    }
  }

  async function handleLoadCommandTaskDetail(item) {
    if (!canOperateCommandTask(item)) {
      setCommandError("当前账号无该任务类型的详情查看权限。");
      return;
    }

    const id = item.taskId || item.id;
    if (!id) return;

    setLoadingCommandDetailId(String(id));
    setCommandError("");

    try {
      const res = await authFetch(`/api/ggg-manager/device-command-tasks/${encodeURIComponent(id)}`);
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "设备指令任务详情加载失败");
      }

      setCommandTaskDetail(await res.json());
    } catch (err) {
      setCommandError(err?.message || "设备指令任务详情加载失败");
      setCommandTaskDetail(null);
    } finally {
      setLoadingCommandDetailId("");
    }
  }

  async function handleCreateFirmwareTask(event) {
    event.preventDefault();
    if (!canFirmwareUpgrade) {
      setFirmwareError("当前账号无固件升级任务权限。");
      return;
    }

    setCreatingFirmwareTask(true);
    setFirmwareError("");

    try {
      const res = await authFetch("/api/ggg-manager/firmware-upgrade-tasks", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          deviceNo: firmwareForm.deviceNo.trim(),
          firmwareVersion: firmwareForm.firmwareVersion.trim(),
          packageName: firmwareForm.packageName.trim(),
          packageFileName: firmwareForm.packageFileName.trim() || null,
          packageChecksum: firmwareForm.packageChecksum.trim() || null,
          remark: firmwareForm.remark.trim() || null
        })
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "固件升级任务创建失败");
      }

      setFirmwareForm((current) => ({
        ...current,
        deviceNo: "",
        firmwareVersion: "",
        packageName: "",
        packageFileName: "",
        packageChecksum: "",
        remark: ""
      }));
      setFirmwareTaskDetail(null);
      await loadFirmwareTasks();
    } catch (err) {
      setFirmwareError(err?.message || "固件升级任务创建失败");
    } finally {
      setCreatingFirmwareTask(false);
    }
  }

  function handleSubmitFirmwareTask(event) {
    if (!window.confirm("确认创建固件升级任务？当前阶段只登记并入队，不上传固件、不读取文件、不真实升级设备，但会记录审计。")) {
      event.preventDefault();
      return;
    }

    handleCreateFirmwareTask(event);
  }

  async function handleCreateFirmwarePackage(event) {
    event.preventDefault();
    if (!canFirmwareUpgrade) {
      setFirmwarePackageError("当前账号无固件包登记权限。");
      return;
    }

    setCreatingFirmwarePackage(true);
    setFirmwarePackageError("");

    try {
      const res = await authFetch("/api/ggg-manager/firmware-packages", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          firmwareVersion: firmwarePackageForm.firmwareVersion.trim(),
          packageName: firmwarePackageForm.packageName.trim(),
          packageFileName: firmwarePackageForm.packageFileName.trim() || null,
          packageChecksum: firmwarePackageForm.packageChecksum.trim(),
          remark: firmwarePackageForm.remark.trim() || null
        })
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "固件包登记失败");
      }

      setFirmwarePackageForm({
        firmwareVersion: "",
        packageName: "",
        packageFileName: "",
        packageChecksum: "",
        remark: ""
      });
      await loadFirmwarePackages();
    } catch (err) {
      setFirmwarePackageError(err?.message || "固件包登记失败");
    } finally {
      setCreatingFirmwarePackage(false);
    }
  }

  async function handleDisableFirmwarePackage(item) {
    if (!canFirmwareUpgrade) {
      setFirmwarePackageError("当前账号无固件包管理权限。");
      return;
    }

    if (!item?.id) return;
    if (!window.confirm("确认停用该固件包登记？不会删除历史记录。")) return;

    setDisablingFirmwarePackageId(String(item.id));
    setFirmwarePackageError("");

    try {
      const res = await authFetch(`/api/ggg-manager/firmware-packages/${encodeURIComponent(item.id)}/disable`, {
        method: "POST"
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "固件包停用失败");
      }

      await loadFirmwarePackages();
    } catch (err) {
      setFirmwarePackageError(err?.message || "固件包停用失败");
    } finally {
      setDisablingFirmwarePackageId("");
    }
  }

  function applyFirmwarePackageToTask(item) {
    setFirmwareForm((current) => ({
      ...current,
      firmwareVersion: item.firmwareVersion || "",
      packageName: item.packageName || "",
      packageFileName: item.packageFileName || "",
      packageChecksum: item.packageChecksum || ""
    }));
  }

  async function handleCancelFirmwareTask(item) {
    if (!canFirmwareUpgrade) {
      setFirmwareError("当前账号无固件升级任务权限。");
      return;
    }

    const id = item.taskId || item.id;
    if (!id) return;

    setCancellingFirmwareId(String(id));
    setFirmwareError("");
    setFirmwareTaskDetail(null);

    try {
      const res = await authFetch(`/api/ggg-manager/firmware-upgrade-tasks/${encodeURIComponent(id)}/cancel`, {
        method: "POST"
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "固件升级任务取消失败");
      }

      await loadFirmwareTasks();
    } catch (err) {
      setFirmwareError(err?.message || "固件升级任务取消失败");
    } finally {
      setCancellingFirmwareId("");
    }
  }

  async function handleCheckFirmwareDispatch(item) {
    if (!canFirmwareUpgrade) {
      setFirmwareError("当前账号无固件升级执行检查权限。");
      return;
    }

    const id = item.taskId || item.id;
    if (!id) return;

    setCheckingFirmwareId(String(id));
    setFirmwareError("");

    try {
      const res = await authFetch(`/api/ggg-manager/firmware-upgrade-tasks/${encodeURIComponent(id)}/dispatch-check`, {
        method: "POST"
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "固件升级执行检查失败");
      }

      const data = await res.json();
      setFirmwareDispatchCheck(data);
      await loadOperationLogs();
    } catch (err) {
      setFirmwareError(err?.message || "固件升级执行检查失败");
    } finally {
      setCheckingFirmwareId("");
    }
  }

  async function handleLoadFirmwareTaskDetail(item) {
    if (!canFirmwareUpgrade) {
      setFirmwareError("当前账号无固件升级任务详情查看权限。");
      return;
    }

    const id = item.taskId || item.id;
    if (!id) return;

    setLoadingFirmwareDetailId(String(id));
    setFirmwareError("");

    try {
      const res = await authFetch(`/api/ggg-manager/firmware-upgrade-tasks/${encodeURIComponent(id)}`);
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "固件升级任务详情加载失败");
      }

      setFirmwareTaskDetail(await res.json());
    } catch (err) {
      setFirmwareError(err?.message || "固件升级任务详情加载失败");
      setFirmwareTaskDetail(null);
    } finally {
      setLoadingFirmwareDetailId("");
    }
  }

  const summary = overview?.summary || {};
  const services = canServiceView && Array.isArray(overview?.services) ? overview.services : [];
  const capabilities = Array.isArray(overview?.capabilities) ? overview.capabilities : [];
  const availableCommandTemplates = commandTemplates.length > 0
    ? commandTemplates
    : canDeviceCommand
      ? [
        { commandType: "read_device_info", name: "设备信息（读）", riskLevel: "low", enabled: true, payloadSchemaHint: commandPayloadPresets.read_device_info },
        { commandType: "read_parameters", name: "工作/网络参数（读）", riskLevel: "low", enabled: true, payloadSchemaHint: commandPayloadPresets.read_parameters_work },
        { commandType: "set_parameters", name: "工作/网络参数（写）", riskLevel: "high", enabled: true, payloadSchemaHint: commandPayloadPresets.set_parameters_work },
        { commandType: "clear_alarm", name: "清除报警", riskLevel: "medium", enabled: true, payloadSchemaHint: commandPayloadPresets.clear_alarm },
        { commandType: "reset_gps_module", name: "重启 GPS 模块", riskLevel: "critical", enabled: true, payloadSchemaHint: commandPayloadPresets.reset_gps_module }
      ]
      : [{ commandType: "read_parameters", name: "工作/网络参数（读）", riskLevel: "low", enabled: true, payloadSchemaHint: commandPayloadPresets.read_parameters_work }];

  const commandDeviceTotalPages = Math.max(1, Math.ceil((commandDeviceTotal || 0) / commandDevicePageSize));
  const commandTaskTotalPages = Math.max(1, Math.ceil((commandTaskTotal || 0) / commandTaskPageSize));

  function renderStatusBadge(status) {
    const normalized = (status || "").toLowerCase();
    const className =
      normalized === "running" || normalized === "ready" || normalized === "active"
        ? "badge bg-success"
        : normalized === "degraded"
          ? "badge bg-warning text-dark"
          : "badge bg-secondary";
    return <span className={className}>{status || "-"}</span>;
  }

  function renderAlarmBadge(level) {
    const normalized = (level || "").toLowerCase();
    const className =
      normalized === "critical"
        ? "badge bg-danger"
        : normalized === "warning"
          ? "badge bg-warning text-dark"
          : "badge bg-info text-dark";
    return <span className={className}>{level || "info"}</span>;
  }

  function renderAlarmStatusBadge(status) {
    const normalized = (status || "").toLowerCase();
    const className =
      normalized === "active"
        ? "badge bg-danger"
        : normalized === "acked"
          ? "badge bg-primary"
          : normalized === "cleared"
            ? "badge bg-success"
            : "badge bg-secondary";
    const label =
      normalized === "active"
        ? "未处理"
        : normalized === "acked"
          ? "已确认"
          : normalized === "cleared"
            ? "已清除"
            : status || "-";
    return <span className={className}>{label}</span>;
  }

  function renderAlarmTreatmentInfo(item) {
    const normalizedStatus = (item.status || "").toLowerCase();
    if (normalizedStatus === "active") {
      return (
        <div className="d-flex flex-column gap-1">
          <span className="badge bg-danger align-self-start">待处理</span>
          <span className="text-muted small">需要管理员确认或等待自动清除。</span>
        </div>
      );
    }

    if (item.ackedAtUtc) {
      return (
        <div className="d-flex flex-column gap-1">
          <span className="badge bg-primary align-self-start">已确认</span>
          <div>{formatDateTime(item.ackedAtUtc)}</div>
          <div className="text-muted small">确认人：{item.ackedBy || "-"}</div>
          {item.ackRemark && <div className="small text-break">备注：{item.ackRemark}</div>}
        </div>
      );
    }

    if (item.clearedAtUtc) {
      return (
        <div className="d-flex flex-column gap-1">
          <span className="badge bg-success align-self-start">已清除</span>
          <div>{formatDateTime(item.clearedAtUtc)}</div>
          <div className="text-muted small">派生条件已恢复。</div>
        </div>
      );
    }

    return "-";
  }

  function renderAlarmDetail(item) {
    return (
      <div className="d-flex flex-column gap-1">
        <div>{item.detail || "-"}</div>
        <div className="d-flex flex-wrap gap-1">
          <span className="badge bg-light text-dark border">首次：{formatDateTime(item.firstSeenAtUtc)}</span>
          <span className="badge bg-light text-dark border">最近：{formatDateTime(item.lastSeenAtUtc || item.generatedAtUtc)}</span>
          {item.clearedAtUtc && <span className="badge bg-light text-dark border">清除：{formatDateTime(item.clearedAtUtc)}</span>}
        </div>
      </div>
    );
  }

  function renderAlarmTreatmentRecordBadge(recordType) {
    const normalized = (recordType || "").toLowerCase();
    const className =
      normalized === "created"
        ? "badge bg-danger"
        : normalized === "acked" || normalized === "ack_operation_log"
          ? "badge bg-primary"
          : normalized === "cleared"
            ? "badge bg-success"
            : "badge bg-secondary";
    const label =
      normalized === "created"
        ? "首次发现"
        : normalized === "acked"
          ? "事件确认"
          : normalized === "ack_operation_log"
            ? "确认审计"
            : normalized === "cleared"
              ? "自动清除"
              : recordType || "-";

    return <span className={className}>{label}</span>;
  }

  function renderAlarmTreatmentRecordsCard() {
    if (!alarmTreatmentRecordDetail) return null;

    const alarm = alarmTreatmentRecordDetail.alarm || {};
    const records = Array.isArray(alarmTreatmentRecordDetail.items) ? alarmTreatmentRecordDetail.items : [];

    return (
      <div className="status-banner info mt-3">
        <div className="d-flex justify-content-between align-items-start gap-3 flex-wrap">
          <div>
            <div className="fw-bold">报警处理记录：{alarm.name || alarm.alarmKey || "-"}</div>
            <div className="small text-muted">
              轻量记录视图，来源于报警事件字段和 GGG_SYSTEM_ALARM_ACK 操作审计。
            </div>
          </div>
          <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => setAlarmTreatmentRecordDetail(null)}>关闭</button>
        </div>
        <div className="mt-2 d-flex flex-wrap gap-2 align-items-center">
          <span className="badge bg-light text-dark border">报警：{alarm.alarmKey || alarm.code || "-"}</span>
          {renderAlarmBadge(alarm.level)}
          {renderAlarmStatusBadge(alarm.status)}
          <span className="badge bg-light text-dark border">来源：{alarm.source || "-"}</span>
        </div>
        <div className="mt-3">
          {records.map((record, index) => (
            <div className="border rounded bg-white p-2 mb-2" key={`${record.recordType}-${record.operationLogId || index}`}>
              <div className="d-flex justify-content-between align-items-start gap-2 flex-wrap">
                <div>
                  <div className="fw-bold">{record.title || "-"}</div>
                  <div className="text-muted small">{formatDateTime(record.occurredAtUtc)} · {record.source || "-"}</div>
                </div>
                <div className="d-flex flex-wrap gap-1">
                  {renderAlarmTreatmentRecordBadge(record.recordType)}
                  {record.operatorUserId && <span className="badge bg-light text-dark border">操作人：{record.operatorUserId}</span>}
                  {record.operationLogId && <span className="badge bg-light text-dark border">日志：#{record.operationLogId}</span>}
                </div>
              </div>
              {record.detail && <div className="small mt-1">{record.detail}</div>}
              {record.remark && <div className="small mt-1">备注：{record.remark}</div>}
              {record.rawDetail && <div className="mt-2">{renderOperationLogDetail(record.rawDetail)}</div>}
            </div>
          ))}
          {records.length === 0 && <div className="status-banner empty m-0">暂无处理记录</div>}
        </div>
      </div>
    );
  }

  function renderCommandStatusBadge(status) {
    const normalized = (status || "").toLowerCase();
    const className =
      normalized === "queued"
        ? "badge bg-primary"
        : normalized === "cancelled"
          ? "badge bg-secondary"
          : normalized === "failed" || normalized === "timeout"
            ? "badge bg-danger"
            : normalized === "sent" || normalized === "acked" || normalized === "completed"
              ? "badge bg-success"
              : "badge bg-info text-dark";
    const label =
      normalized === "queued"
        ? "已入队"
        : normalized === "cancelled"
          ? "已取消"
          : normalized === "sent"
            ? "已发送"
            : normalized || "-";
    return <span className={className}>{label}</span>;
  }

  function canCancelCommandTask(status) {
    return (status || "").toLowerCase() === "queued";
  }

  function renderDeviceOnlineBadge(device) {
    if (device?.runtimeOnline) {
      return <span className="badge bg-success">在线可直发</span>;
    }

    if (device?.netState === 1) {
      return <span className="badge bg-warning text-dark">DB 在线</span>;
    }

    return <span className="badge bg-secondary">离线排队</span>;
  }

  function renderTaskStateHints(kind) {
    const executorLabel = kind === "firmware" ? "固件升级执行器" : "设备指令执行器";
    return (
      <div className="d-flex flex-wrap gap-1">
        <span className="badge bg-primary">queued：已入队</span>
        <span className="badge bg-secondary">cancelled：已取消</span>
        <span className="badge bg-success">sent/acked/completed：已发送/已确认/已完成</span>
        <span className="badge bg-light text-dark border">failed/timeout：预留异常态</span>
        <span className="badge bg-warning text-dark">{executorLabel} 关闭时任务保持排队</span>
      </div>
    );
  }

  function renderTaskTimeline(item, fields) {
    return (
      <div className="d-flex flex-wrap gap-1">
        {fields.map(({ key, label }) => (
          <span className="badge bg-light text-dark border" key={key}>{label}：{formatDateTime(item?.[key])}</span>
        ))}
      </div>
    );
  }

  function renderTaskAuditRecords(records) {
    const items = Array.isArray(records) ? records : [];

    return (
      <div className="mt-3">
        <div className="fw-bold small mb-2">任务审计记录</div>
        {items.map((record, index) => (
          <div className="border rounded bg-white p-2 mb-2" key={`${record.operationLogId || "audit"}-${index}`}>
            <div className="d-flex justify-content-between align-items-start gap-2 flex-wrap">
              <div>
                <div className="fw-bold">{record.title || record.opType || "-"}</div>
                <div className="text-muted small">
                  {formatDateTime(record.occurredAtUtc)} · {record.action || "-"}
                </div>
              </div>
              <div className="d-flex flex-wrap gap-1">
                {record.opType && <span className="badge bg-light text-dark border">{record.opType}</span>}
                {record.operatorUserId && <span className="badge bg-light text-dark border">操作人：{record.operatorUserId}</span>}
                {record.operationLogId && <span className="badge bg-light text-dark border">日志：#{record.operationLogId}</span>}
              </div>
            </div>
            {record.detail && <div className="small mt-1">{record.detail}</div>}
            {record.rawDetail && <div className="mt-2">{renderOperationLogDetail(record.rawDetail)}</div>}
          </div>
        ))}
        {items.length === 0 && <div className="status-banner empty m-0">暂无任务审计记录</div>}
      </div>
    );
  }

  function renderCommandTaskDetailCard() {
    if (!commandTaskDetail) return null;

    return (
      <div className="status-banner info mt-3">
        <div className="d-flex justify-content-between align-items-start gap-3 flex-wrap">
          <div>
            <div className="fw-bold">设备指令任务详情 #{commandTaskDetail.taskId || commandTaskDetail.id}</div>
            <div className="small text-muted">
              只读详情。发送状态来自后台执行器或在线直发接口。
            </div>
          </div>
          <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => setCommandTaskDetail(null)}>关闭</button>
        </div>
        <div className="mt-2 d-flex flex-wrap gap-2 align-items-center">
          <span className="badge bg-light text-dark border">设备：{renderDeviceMonitorLink(commandTaskDetail.deviceNo)}</span>
          <span className="badge bg-light text-dark border">车辆：{commandTaskDetail.vehicleNo || "-"}</span>
          <span className="badge bg-light text-dark border">指令：{commandTaskDetail.commandName || commandTaskDetail.commandType}</span>
          {renderCommandStatusBadge(commandTaskDetail.status)}
        </div>
        <div className="mt-2">{renderTaskStateHints("command")}</div>
        <div className="mt-2">
          {renderTaskTimeline(commandTaskDetail, [
            { key: "requestedAtUtc", label: "创建" },
            { key: "queuedAtUtc", label: "入队" },
            { key: "sentAtUtc", label: "发送" },
            { key: "completedAtUtc", label: "完成" },
            { key: "cancelledAtUtc", label: "取消" }
          ])}
        </div>
        <div className="mt-2 small">
          <div>发起人：{commandTaskDetail.requestedBy || "-"}</div>
          <div>优先级：{commandTaskDetail.priority ?? "-"}</div>
          <div>结果：{commandTaskDetail.errorMessage || commandTaskDetail.resultMessage || "-"}</div>
          <div>备注：{commandTaskDetail.remark || "-"}</div>
        </div>
        {commandTaskDetail.payloadJson && (
          <code className="d-block text-wrap small mt-2">{commandTaskDetail.payloadJson}</code>
        )}
        {renderTaskAuditRecords(commandTaskDetail.auditRecords)}
      </div>
    );
  }

  function renderFirmwareTaskDetailCard() {
    if (!firmwareTaskDetail) return null;

    return (
      <div className="status-banner info mt-3">
        <div className="d-flex justify-content-between align-items-start gap-3 flex-wrap">
          <div>
            <div className="fw-bold">固件升级任务详情 #{firmwareTaskDetail.taskId || firmwareTaskDetail.id}</div>
            <div className="small text-muted">
              只读详情。当前阶段不上传固件、不读取文件、不真实升级设备。
            </div>
          </div>
          <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => setFirmwareTaskDetail(null)}>关闭</button>
        </div>
        <div className="mt-2 d-flex flex-wrap gap-2 align-items-center">
          <span className="badge bg-light text-dark border">设备：{renderDeviceMonitorLink(firmwareTaskDetail.deviceNo)}</span>
          <span className="badge bg-light text-dark border">车辆：{firmwareTaskDetail.vehicleNo || "-"}</span>
          <span className="badge bg-light text-dark border">目标版本：{firmwareTaskDetail.firmwareVersion}</span>
          <span className="badge bg-light text-dark border">进度：{firmwareTaskDetail.progress ?? 0}%</span>
          {renderCommandStatusBadge(firmwareTaskDetail.status)}
        </div>
        <div className="mt-2">{renderTaskStateHints("firmware")}</div>
        <div className="mt-2">
          {renderTaskTimeline(firmwareTaskDetail, [
            { key: "requestedAtUtc", label: "创建" },
            { key: "queuedAtUtc", label: "入队" },
            { key: "startedAtUtc", label: "开始" },
            { key: "completedAtUtc", label: "完成" },
            { key: "cancelledAtUtc", label: "取消" }
          ])}
        </div>
        <div className="mt-2 small">
          <div>发起人：{firmwareTaskDetail.requestedBy || "-"}</div>
          <div>固件包：{firmwareTaskDetail.packageName || "-"}</div>
          <div>文件名：{firmwareTaskDetail.packageFileName || "-"}</div>
          <div>校验值：{firmwareTaskDetail.packageChecksum || "-"}</div>
          <div>结果：{firmwareTaskDetail.errorMessage || firmwareTaskDetail.resultMessage || "-"}</div>
          <div>备注：{firmwareTaskDetail.remark || "-"}</div>
        </div>
        {renderTaskAuditRecords(firmwareTaskDetail.auditRecords)}
      </div>
    );
  }

  function isParameterCommandType(commandType) {
    const normalized = (commandType || "").toLowerCase();
    return normalized === "read_parameters" || normalized === "set_parameters";
  }

  function canOperateCommandType(commandType) {
    return isParameterCommandType(commandType) ? canDeviceParameter : canDeviceCommand;
  }

  function canOperateCommandTask(item) {
    return canOperateCommandType(item?.commandType);
  }

  function getCommandActionByKey(key) {
    return commandActionOptions.find((item) => item.key === key) || null;
  }

  function openCommandModal(device, actionKey) {
    const action = getCommandActionByKey(actionKey);
    if (!device || !action) return;
    selectCommandDevice(device);
    setCommandModal({ open: true, device, action, result: null });
  }

  function closeCommandModal() {
    if (sendingCommand) return;
    setCommandModal({ open: false, device: null, action: null, result: null });
  }

  function getCommandModalInitialValues(action) {
    const defaults = commandWriteDefaults[action?.key] || {};
    return {
      ...defaults,
      remark: ""
    };
  }

  function getCommandModalFields(action) {
    if (!action) return [];
    if (action.key === "write_work") {
      return [
        { name: "sampleCycle", label: "采样周期", type: "number", required: true },
        { name: "uploadCycle", label: "上传周期", type: "number", required: true },
        { name: "com1Baudrate", label: "COM1 波特率", type: "number", required: true },
        { name: "com1Use", label: "COM1 用途", type: "number", required: true },
        { name: "workButton", label: "工作按钮", type: "number", required: true },
        { name: "barcodeDataType", label: "条码数据类型", type: "number", required: true },
        { name: "remark", label: "备注", placeholder: "可留空" }
      ];
    }

    if (action.key === "write_network") {
      return [
        { name: "valid1", label: "主链路启用", type: "number", required: true },
        { name: "apn1", label: "主链路 APN" },
        { name: "userName1", label: "主链路用户名" },
        { name: "password1", label: "主链路密码" },
        { name: "dialnum1", label: "主链路拨号号码" },
        { name: "dnsIp1", label: "主链路 DNS" },
        { name: "domainName1", label: "主链路域名" },
        { name: "serverIp1", label: "主链路服务器 IP" },
        { name: "serverPort1", label: "主链路服务器端口" },
        { name: "deviceNo1", label: "主链路设备号" },
        { name: "valid2", label: "备用链路启用", type: "number", required: true },
        { name: "apn2", label: "备用链路 APN" },
        { name: "userName2", label: "备用链路用户名" },
        { name: "password2", label: "备用链路密码" },
        { name: "dialnum2", label: "备用链路拨号号码" },
        { name: "dnsIp2", label: "备用链路 DNS" },
        { name: "domainName2", label: "备用链路域名" },
        { name: "serverIp2", label: "备用链路服务器 IP" },
        { name: "serverPort2", label: "备用链路服务器端口" },
        { name: "deviceNo2", label: "备用链路设备号" },
        { name: "remark", label: "备注", placeholder: "可留空" }
      ];
    }

    return [{ name: "remark", label: "备注", placeholder: "可留空" }];
  }

  function buildCommandPayload(action, form) {
    if (!action) return "{}";
    if (action.kind !== "write") {
      return commandPayloadPresets[action.presetKey] || "{}";
    }

    const payload = { ...(commandWriteDefaults[action.key] || {}) };
    const numberFields = new Set([
      "protocolVersion",
      "sampleCycle",
      "uploadCycle",
      "com1Baudrate",
      "com1Use",
      "workButton",
      "barcodeDataType",
      "valid1",
      "valid2"
    ]);

    Object.keys(payload).forEach((key) => {
      if (!(key in form)) return;
      payload[key] = numberFields.has(key)
        ? Number(form[key] || 0)
        : String(form[key] ?? "");
    });

    return JSON.stringify(payload);
  }

  async function submitCommandModal(form) {
    const { device, action } = commandModal;
    if (!device?.deviceNo || !action) {
      setCommandError("请选择设备和指令。");
      return;
    }

    const needsConfirm = ["medium", "high", "critical"].includes((action.riskLevel || "").toLowerCase());
    if (needsConfirm) {
      const modeText = device.runtimeOnline ? "下发到在线设备" : "创建离线任务";
      const ok = window.confirm(`确认${modeText}：${action.label}？`);
      if (!ok) return;
    }

    setSendingCommand(true);
    setCommandError("");
    setCommandSendResult(null);

    try {
      const res = await authFetch("/api/ggg-manager/device-command-send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          deviceId: device.deviceId || device.id || null,
          deviceNo: device.deviceNo,
          commandType: action.commandType,
          payloadJson: buildCommandPayload(action, form),
          remark: String(form.remark || "").trim() || null,
          confirmed: needsConfirm
        })
      });
      const data = await res.json().catch(() => null);
      if (!res.ok) {
        throw new Error(data?.message || "设备指令执行失败");
      }

      setCommandSendResult(data);
      setCommandModal((current) => ({ ...current, result: data }));
      setCommandTaskDetail(null);
      await Promise.all([loadCommandData(), loadOperationLogs()]);
    } catch (err) {
      setCommandError(err?.message || "设备指令执行失败");
      setCommandModal((current) => ({
        ...current,
        result: { status: "failed", message: err?.message || "设备指令执行失败" }
      }));
    } finally {
      setSendingCommand(false);
    }
  }

  function renderCommandResultPayload(payload) {
    if (!payload || typeof payload !== "object") {
      return <div className="text-muted small">无返回参数</div>;
    }

    const entries = Object.entries(payload);
    if (entries.length === 0) {
      return <div className="text-muted small">无返回参数</div>;
    }

    return (
      <div className="table-responsive">
        <table className="table table-sm table-bordered align-middle mb-0">
          <tbody>
            {entries.map(([key, value]) => (
              <tr key={key}>
                <th className="bg-light" style={{ width: 180 }}>{key}</th>
                <td>{value && typeof value === "object" ? JSON.stringify(value) : String(value ?? "")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  function noPermissionBlock(label) {
    return <div className="status-banner warn mt-3">当前账号无 {label} 权限。</div>;
  }

  function getMonitorPath(deviceNo) {
    const normalized = String(deviceNo || "").trim();
    return normalized ? `/gps-monitor?deviceNo=${encodeURIComponent(normalized)}` : "/gps-monitor";
  }

  function renderDeviceMonitorLink(deviceNo, fallback = "-") {
    const normalized = String(deviceNo || "").trim();
    if (!normalized) return fallback;

    return (
      <Link to={getMonitorPath(normalized)} title="跳到实时监控并定位该设备">
        {normalized}
      </Link>
    );
  }

  function renderClientSourceBadge(source) {
    const normalized = (source || "").toLowerCase();
    const className =
      normalized === "web"
        ? "badge bg-primary"
        : normalized === "device"
          ? "badge bg-success"
          : "badge bg-secondary";
    const label =
      normalized === "web"
        ? "Web 用户"
        : normalized === "device"
          ? "设备"
          : source || "未知";
    return <span className={className}>{label}</span>;
  }

  function renderConnectionActionBadge(logType, actionLabel) {
    const isLogin = Number(logType) === 1;
    return <span className={isLogin ? "badge bg-success" : "badge bg-secondary"}>{actionLabel || (isLogin ? "登入" : "登出")}</span>;
  }

  function formatOperationLogValue(value) {
    if (value === null || value === undefined || value === "") return "-";
    if (typeof value === "boolean") return value ? "是" : "否";
    if (Array.isArray(value)) return value.length > 0 ? value.join("，") : "-";
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
  }

  function parseOperationLogDetail(detail) {
    const raw = detail || "";
    if (!raw) return { raw, parsed: null, fields: [] };

    try {
      const parsed = JSON.parse(raw);
      const fields = [];

      for (const key of ["module", "action"]) {
        if (parsed[key] !== null && parsed[key] !== undefined && parsed[key] !== "") {
          fields.push({ section: "", key, value: parsed[key] });
        }
      }

      for (const sectionKey of ["target", "before", "after", "extra"]) {
        const sectionValue = parsed[sectionKey];
        if (!sectionValue || typeof sectionValue !== "object" || Array.isArray(sectionValue)) {
          if (sectionValue !== null && sectionValue !== undefined && sectionValue !== "") {
            fields.push({ section: sectionKey, key: sectionKey, value: sectionValue });
          }
          continue;
        }

        Object.entries(sectionValue)
          .filter(([, value]) => value !== null && value !== undefined && value !== "")
          .forEach(([key, value]) => fields.push({ section: sectionKey, key, value }));
      }

      return { raw, parsed, fields };
    } catch {
      return { raw, parsed: null, fields: [] };
    }
  }

  function getOperationLogFieldClassName(key, value) {
    const normalizedKey = String(key || "").toLowerCase();
    const normalizedValue = String(value || "").toLowerCase();

    if (normalizedKey.includes("blocker") || normalizedValue.includes("blocked")) return "badge bg-warning text-dark";
    if (normalizedKey.includes("warning")) return "badge bg-info text-dark";
    if (normalizedKey.includes("status") && (normalizedValue === "queued" || normalizedValue === "ready")) return "badge bg-primary";
    if (normalizedKey.includes("status") && (normalizedValue === "cancelled" || normalizedValue === "failed")) return "badge bg-secondary";
    if (normalizedKey.includes("enabled") || normalizedKey.includes("online") || normalizedKey.includes("dispatch") || normalizedKey.includes("registered")) {
      return value === true ? "badge bg-success" : "badge bg-secondary";
    }
    if (normalizedKey.includes("device")) return "badge bg-light text-dark border border-primary";
    return "badge bg-light text-dark border";
  }

  function renderOperationLogDetail(detail) {
    const parsed = parseOperationLogDetail(detail);
    if (!parsed.raw) return "-";

    const visibleFields = parsed.fields.slice(0, 10);

    return (
      <div className="d-flex flex-column gap-1">
        {visibleFields.length > 0 && (
          <div className="d-flex flex-wrap gap-1">
            {visibleFields.map((field, index) => {
              const label = operationLogFieldLabels[field.key] || field.key;
              const sectionLabel = operationLogSectionLabels[field.section];
              const value = formatOperationLogValue(field.value);

              return (
                <span className={getOperationLogFieldClassName(field.key, field.value)} key={`${field.section}-${field.key}-${index}`}>
                  {sectionLabel ? `${sectionLabel}.` : ""}{label}：{value}
                </span>
              );
            })}
            {parsed.fields.length > visibleFields.length && (
              <span className="badge bg-light text-dark border">更多字段：{parsed.fields.length - visibleFields.length}</span>
            )}
          </div>
        )}
        <code className="d-block text-wrap small">{parsed.raw}</code>
      </div>
    );
  }

  function formatDateTime(value) {
    if (!value) return "-";
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? "-" : date.toLocaleString();
  }

  function canSeeSection(item) {
    if (item.key === "commands") return canDeviceOps;
    if (item.key === "config") return canAlarmConfig || canProgramConfig;
    return can(item.permission);
  }

  const activeErrors = [
    (showOverview || showServices) && error,
    showServices && serviceLogError,
    showClients && clientError,
    showCommands && commandError,
    showFirmware && firmwareError,
    showFirmware && firmwarePackageError,
    showAlarms && alarmError,
    showConfig && ruleError,
    showConfig && configError,
    showLogs && logError
  ].filter(Boolean);

  return (
    <div className="container-fluid">
      <div className="card shadow-sm status-card mt-3">
        <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
          <span>GGG 管理 - {gggManagerSections.find((item) => item.key === activeSection)?.label || "总览"}</span>
          <button
            className="btn btn-sm btn-light"
            type="button"
            onClick={loadPageData}
            disabled={loading || alarmLoading || ruleLoading || configLoading || commandLoading || firmwareLoading || firmwarePackageLoading || clientLoading || logLoading || serviceLogLoading}
          >
            {loading || alarmLoading || ruleLoading || configLoading || commandLoading || firmwareLoading || firmwarePackageLoading || clientLoading || logLoading || serviceLogLoading ? "刷新中..." : "刷新"}
          </button>
        </div>
        <div className="card-body">
          <nav className="nav nav-pills flex-wrap gap-2 mt-3">
            {gggManagerSections.filter(canSeeSection).map((item) => (
              <NavLink
                key={item.key}
                to={item.to}
                end={item.key === "overview"}
                className={({ isActive }) => `nav-link py-1 px-3${isActive ? " active" : ""}`}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          {activeErrors.map((item) => (
            <div className="status-banner error mt-3" key={item}>{item}</div>
          ))}

          {showOverview && (
            <>
          <div className="row g-3 mt-1">
            <div className="col-md-3">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <div className="text-muted">客户数</div>
                  <div className="fs-3 fw-bold">{summary.customerCount ?? "-"}</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <div className="text-muted">用户数</div>
                  <div className="fs-3 fw-bold">{summary.userCount ?? "-"}</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <div className="text-muted">设备数</div>
                  <div className="fs-3 fw-bold">{summary.deviceCount ?? "-"}</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <div className="text-muted">DB 在线设备</div>
                  <div className="fs-3 fw-bold">{summary.onlineDeviceCount ?? "-"}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-3 mt-1">
            <div className="col-md-3">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <div className="text-muted">内存连接数</div>
                  <div className="fs-3 fw-bold">{summary.activeConnectionCount ?? "-"}</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <div className="text-muted">Redis 状态</div>
                  <div className="fs-5 fw-bold">{summary.redisConnected ? "已连接" : "未连接"}</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <div className="text-muted">心跳 TTL</div>
                  <div className="fs-3 fw-bold">{summary.redisHeartbeatTtlSeconds ?? "-"}</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <div className="text-muted">样本上限</div>
                  <div className="fs-3 fw-bold">{summary.onlineDeviceSampleLimit ?? "-"}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-3 mt-1">
            <div className="col-md-3">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <div className="text-muted">排队指令任务</div>
                  <div className="fs-3 fw-bold">{summary.queuedDeviceCommandTaskCount ?? "-"}</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <div className="text-muted">排队升级任务</div>
                  <div className="fs-3 fw-bold">{summary.queuedFirmwareUpgradeTaskCount ?? "-"}</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <div className="text-muted">启用固件包</div>
                  <div className="fs-3 fw-bold">{summary.activeFirmwarePackageCount ?? "-"}</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <div className="text-muted">近 24h GGG 审计</div>
                  <div className="fs-3 fw-bold">{summary.recentGggOperationLogCount ?? "-"}</div>
                  <div className="text-muted small">客户端登入：{summary.recentClientLoginCount ?? "-"}</div>
                  <div className="text-muted small">未处理报警：{summary.activeSystemAlarmCount ?? "-"}</div>
                </div>
              </div>
            </div>
          </div>

            </>
          )}

          {showOverview && (
            <>
          <div className="card border-0 shadow-sm mt-4">
            <div className="card-body">
              <div className="fw-bold mb-2">在线设备样本</div>
              <div className="text-muted small mb-2">来源：当前 Web 进程内存连接，最多展示前 {summary.onlineDeviceSampleLimit ?? 20} 个。</div>
              {Array.isArray(summary.onlineDeviceSamples) && summary.onlineDeviceSamples.length > 0 ? (
                <div className="d-flex flex-wrap gap-2">
                  {summary.onlineDeviceSamples.map((deviceNo) => (
                    <span className="badge bg-light text-dark border" key={deviceNo}>{renderDeviceMonitorLink(deviceNo)}</span>
                  ))}
                </div>
              ) : (
                <div className="status-banner empty m-0">暂无在线设备样本</div>
              )}
            </div>
          </div>
            </>
          )}

          {showServices && (
          <div className="card border-0 shadow-sm mt-4">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <div className="fw-bold">服务状态检查日志</div>
                  <div className="text-muted small">最近 20 条主动检查快照，来源于独立服务状态日志表。</div>
                </div>
                <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => loadServiceLogs()} disabled={!canServiceView || serviceLogLoading}>
                  {serviceLogLoading ? "加载中..." : "刷新服务日志"}
                </button>
              </div>

              {!canServiceView && noPermissionBlock("服务状态检查日志")}
              <form className="row g-2 align-items-end mb-3" onSubmit={handleApplyServiceLogFilters}>
                <div className="col-md-4">
                  <label className="form-label small text-muted">服务模块</label>
                  <input
                    className="form-control form-control-sm"
                    value={serviceLogFilters.moduleName}
                    onChange={(event) => updateServiceLogFilter("moduleName", event.target.value)}
                    placeholder="按模块名称模糊查询"
                    disabled={!canServiceView || serviceLogLoading}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label small text-muted">状态</label>
                  <select
                    className="form-select form-select-sm"
                    value={serviceLogFilters.status}
                    onChange={(event) => updateServiceLogFilter("status", event.target.value)}
                    disabled={!canServiceView || serviceLogLoading}
                  >
                    <option value="all">全部状态</option>
                    <option value="running">running</option>
                    <option value="degraded">degraded</option>
                    <option value="offline">offline</option>
                    <option value="unknown">unknown</option>
                  </select>
                </div>
                <div className="col-md-5">
                  <div className="d-flex gap-2">
                    <button className="btn btn-sm btn-outline-primary flex-fill" type="submit" disabled={!canServiceView || serviceLogLoading}>
                      {serviceLogLoading ? "查询中..." : "查询服务日志"}
                    </button>
                    <button className="btn btn-sm btn-outline-secondary flex-fill" type="button" onClick={handleClearServiceLogFilters} disabled={!canServiceView || serviceLogLoading}>
                      清空
                    </button>
                  </div>
                </div>
              </form>
              <div className="table-responsive">
                <table className="table table-sm table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>检查时间</th>
                      <th>批次</th>
                      <th>服务模块</th>
                      <th>状态</th>
                      <th>来源</th>
                      <th>最后心跳</th>
                      <th>详情</th>
                    </tr>
                  </thead>
                  <tbody>
                    {serviceLogs.map((item) => (
                      <tr key={item.id}>
                        <td>{formatDateTime(item.checkedAtUtc)}</td>
                        <td><code>{String(item.checkBatchId || "").slice(0, 8) || "-"}</code></td>
                        <td>
                          <div>{item.moduleName || "-"}</div>
                          <div className="text-muted small">{item.moduleType || "-"} / {item.ipAddress || "-"}</div>
                        </td>
                        <td>{renderStatusBadge(item.status)}</td>
                        <td>
                          <span className="badge bg-light text-dark border">{item.source || "-"}</span>
                        </td>
                        <td>{formatDateTime(item.lastHeartbeatUtc)}</td>
                        <td>
                          <div>{item.detail || "-"}</div>
                          {item.statusInfoJson && <code className="d-block text-wrap small">{item.statusInfoJson}</code>}
                        </td>
                      </tr>
                    ))}
                    {!serviceLogLoading && serviceLogs.length === 0 && (
                      <tr>
                        <td colSpan={7}>
                          <div className="status-banner empty m-0">暂无服务状态检查日志</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          )}

          {showClients && (
          <div className="card border-0 shadow-sm mt-4">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <div className="fw-bold">客户端监控</div>
                  <div className="text-muted small">基于连接日志展示最近在线推导和活动记录，不代表强一致会话状态。</div>
                </div>
                <button className="btn btn-sm btn-outline-secondary" type="button" onClick={loadClientMonitoring} disabled={!canClientView || clientLoading}>
                  {clientLoading ? "加载中..." : "刷新客户端"}
                </button>
              </div>

              {!canClientView && noPermissionBlock("客户端监控")}
              {canClientView && clientSourceNote && <div className="status-banner info mb-3">{clientSourceNote}</div>}

              <div className="row g-3">
                <div className="col-lg-6">
                  <div className="fw-bold mb-2">最近在线推导</div>
                  <div className="table-responsive">
                    <table className="table table-sm table-hover align-middle">
                      <thead className="table-light">
                        <tr>
                          <th>来源</th>
                          <th>名称</th>
                          <th>地址</th>
                          <th>最近活动</th>
                        </tr>
                      </thead>
                      <tbody>
                        {clientOnlineItems.map((item) => (
                          <tr key={item.sessionKey}>
                            <td>{renderClientSourceBadge(item.source)}</td>
                            <td>
                              <div>{item.deviceNo ? renderDeviceMonitorLink(item.deviceNo) : (item.displayName || item.loginName || "-")}</div>
                              <div className="text-muted small">{item.vehicleNo || item.loginName || "-"}</div>
                            </td>
                            <td>{item.ipAddress || "-"}{item.port ? `:${item.port}` : ""}</td>
                            <td>{formatDateTime(item.lastSeenAtUtc)}</td>
                          </tr>
                        ))}
                        {!clientLoading && clientOnlineItems.length === 0 && (
                          <tr>
                            <td colSpan={4}>
                              <div className="status-banner empty m-0">暂无在线客户端推导记录</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="fw-bold mb-2">最近连接活动</div>
                  <div className="table-responsive">
                    <table className="table table-sm table-hover align-middle">
                      <thead className="table-light">
                        <tr>
                          <th>时间</th>
                          <th>来源</th>
                          <th>动作</th>
                          <th>名称</th>
                        </tr>
                      </thead>
                      <tbody>
                        {clientConnectionLogs.map((item) => (
                          <tr key={item.id}>
                            <td>{formatDateTime(item.logTimeUtc)}</td>
                            <td>{renderClientSourceBadge(item.source)}</td>
                            <td>{renderConnectionActionBadge(item.logType, item.actionLabel)}</td>
                            <td>
                              <div>{item.deviceNo ? renderDeviceMonitorLink(item.deviceNo) : (item.displayName || item.loginName || "-")}</div>
                              <div className="text-muted small">{item.ipAddress || "-"}{item.port ? `:${item.port}` : ""}</div>
                            </td>
                          </tr>
                        ))}
                        {!clientLoading && clientConnectionLogs.length === 0 && (
                          <tr>
                            <td colSpan={4}>
                              <div className="status-banner empty m-0">暂无客户端连接活动</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          )}

          {showCommands && (
            <>
              <ul className="nav nav-tabs mt-4">
                <li className="nav-item">
                  <button
                    className={`nav-link ${commandActiveTab === "devices" ? "active" : ""}`}
                    type="button"
                    onClick={() => setCommandActiveTab("devices")}
                  >
                    设备操作
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${commandActiveTab === "tasks" ? "active" : ""}`}
                    type="button"
                    onClick={() => setCommandActiveTab("tasks")}
                  >
                    任务查询
                  </button>
                </li>
              </ul>

              <div className="card border-0 shadow-sm rounded-top-0">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <div className="fw-bold">设备指令控制台</div>
                      <div className="text-muted small">按客户和在线状态选择设备，在列表中直接选择指令；在线设备执行并等待返回，离线设备创建任务。</div>
                    </div>
                    <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => loadCommandData()} disabled={!canDeviceOps || commandLoading}>
                      {commandLoading ? "加载中..." : "刷新"}
                    </button>
                  </div>

                  {!canDeviceOps && noPermissionBlock("设备指令/参数任务")}
                  {canDeviceOps && !canDeviceCommand && (
                    <div className="status-banner warn mt-3">当前账号仅有设备参数权限，只能操作参数读取/写入指令。</div>
                  )}

                  {commandActiveTab === "devices" && (
                    <>
                      <form className="row g-2 align-items-end mb-2" onSubmit={handleApplyCommandDeviceFilters}>
                        <div className="col-md-3">
                          <label className="form-label small text-muted">客户</label>
                          <select
                            className="form-select form-select-sm"
                            value={commandDeviceFilters.customerId}
                            onChange={(event) => updateCommandDeviceFilter("customerId", event.target.value)}
                            disabled={!canDeviceOps || commandLoading}
                          >
                            <option value="all">全部客户</option>
                            {commandCustomerOptions.map((item) => (
                              <option key={item.id} value={item.id}>{item.name || item.code || item.id}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-3">
                          <label className="form-label small text-muted">在线状态</label>
                          <select
                            className="form-select form-select-sm"
                            value={commandDeviceFilters.online}
                            onChange={(event) => updateCommandDeviceFilter("online", event.target.value)}
                            disabled={!canDeviceOps || commandLoading}
                          >
                            <option value="all">全部设备</option>
                            <option value="online">在线可直发</option>
                            <option value="offline">离线/无连接</option>
                          </select>
                        </div>
                        <div className="col-md-4">
                          <label className="form-label small text-muted">设备/车牌/客户</label>
                          <input
                            className="form-control form-control-sm"
                            value={commandDeviceFilters.keyword}
                            onChange={(event) => updateCommandDeviceFilter("keyword", event.target.value)}
                            placeholder="输入关键字"
                            disabled={!canDeviceOps || commandLoading}
                          />
                        </div>
                        <div className="col-md-2">
                          <div className="d-flex gap-2">
                            <button className="btn btn-sm btn-outline-primary flex-fill" type="submit" disabled={!canDeviceOps || commandLoading}>
                              查询
                            </button>
                            <button className="btn btn-sm btn-outline-secondary flex-fill" type="button" onClick={handleClearCommandDeviceFilters} disabled={!canDeviceOps || commandLoading}>
                              清空
                            </button>
                          </div>
                        </div>
                      </form>

                      <div className="table-responsive border rounded">
                        <table className="table table-sm table-hover align-middle mb-0">
                          <thead className="table-light">
                            <tr>
                              <th>设备</th>
                              <th>客户/分组</th>
                              <th>在线</th>
                              <th>最近时间</th>
                              <th style={{ minWidth: 180 }}>操作</th>
                            </tr>
                          </thead>
                          <tbody>
                            {commandDevices.map((device) => {
                              const selected = selectedCommandDevice?.deviceNo === device.deviceNo;
                              return (
                                <tr
                                  key={device.deviceId || device.id || device.deviceNo}
                                  className={selected ? "table-active" : ""}
                                  onClick={() => selectCommandDevice(device)}
                                >
                                  <td>
                                    <div className="fw-semibold">{device.vehicleNo || "-"}</div>
                                    <div className="small">{renderDeviceMonitorLink(device.deviceNo)}</div>
                                  </td>
                                  <td>
                                    <div>{device.customerName || "-"}</div>
                                    <div className="text-muted small">{device.groupName || "-"}</div>
                                  </td>
                                  <td>
                                    {renderDeviceOnlineBadge(device)}
                                    {device.onlineStateText && <div className="text-muted small mt-1">{device.onlineStateText}</div>}
                                  </td>
                                  <td>
                                    <div>{formatDateTime(device.lastGpsTimeUtc)}</div>
                                    <div className="text-muted small">{formatDateTime(device.lastUpdateTimeUtc)}</div>
                                  </td>
                                  <td onClick={(event) => event.stopPropagation()}>
                                    <select
                                      className="form-select form-select-sm"
                                      value=""
                                      disabled={!canDeviceOps || commandLoading || sendingCommand}
                                      onChange={(event) => openCommandModal(device, event.target.value)}
                                    >
                                      <option value="">选择指令</option>
                                      {commandActionOptions
                                        .filter((action) => canOperateCommandType(action.commandType))
                                        .map((action) => (
                                          <option key={action.key} value={action.key}>{action.label}</option>
                                        ))}
                                    </select>
                                  </td>
                                </tr>
                              );
                            })}
                            {!commandLoading && commandDevices.length === 0 && (
                              <tr>
                                <td colSpan={5}>
                                  <div className="status-banner empty m-0">暂无可操作设备</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      <div className="d-flex justify-content-between align-items-center mt-2 flex-wrap gap-2">
                        <div className="text-muted small">
                          共 {commandDeviceTotal} 台，当前第 {commandDevicePage} / {commandDeviceTotalPages} 页
                        </div>
                        <div className="btn-group btn-group-sm">
                          <button className="btn btn-outline-secondary" type="button" disabled={commandLoading || commandDevicePage <= 1} onClick={() => changeCommandDevicePage(commandDevicePage - 1)}>
                            上一页
                          </button>
                          <button className="btn btn-outline-secondary" type="button" disabled={commandLoading || commandDevicePage >= commandDeviceTotalPages} onClick={() => changeCommandDevicePage(commandDevicePage + 1)}>
                            下一页
                          </button>
                        </div>
                      </div>

                      {commandSendResult && (
                        <div className={commandSendResult.status === "failed" ? "status-banner warning mt-3" : "status-banner success mt-3"}>
                          <div className="fw-bold">{commandSendResult.queuedOnly ? "离线任务结果" : "设备指令结果"}</div>
                          <div className="mt-1">{commandSendResult.message || "-"}</div>
                        </div>
                      )}
                    </>
                  )}

                  {commandActiveTab === "tasks" && (
                    <>
                      {commandDispatchCheck && (
                        <div className="status-banner warning mt-3">
                          <div className="d-flex flex-wrap justify-content-between gap-2">
                            <div>
                              <div className="fw-bold">发送安全检查结果</div>
                              <div className="small text-muted">
                                任务：#{commandDispatchCheck.taskId}，设备：{commandDispatchCheck.deviceNo}，指令：{commandDispatchCheck.commandType}
                              </div>
                            </div>
                            <div>
                              <span className={commandDispatchCheck.checkStatus === "ready" ? "badge bg-success me-2" : "badge bg-warning text-dark me-2"}>
                                {commandDispatchCheck.checkStatus || "blocked"}
                              </span>
                              <span className={commandDispatchCheck.executorEnabled ? "badge bg-success me-2" : "badge bg-secondary me-2"}>
                                执行器：{commandDispatchCheck.executorEnabled ? "已开启" : "关闭"}
                              </span>
                              <span className={commandDispatchCheck.deviceOnline ? "badge bg-success" : "badge bg-secondary"}>
                                设备：{commandDispatchCheck.deviceOnline ? "在线" : "未在线"}
                              </span>
                            </div>
                          </div>
                          <div className="mt-2 small">
                            协议帧长度：{commandDispatchCheck.protocolFrameLength ?? "-"}，外层链路帧：{commandDispatchCheck.linkFrameType || "-"} / {commandDispatchCheck.linkFrameLength ?? "-"}
                          </div>
                          {Array.isArray(commandDispatchCheck.blockers) && commandDispatchCheck.blockers.length > 0 && (
                            <div className="mt-2">
                              <div className="fw-bold small">阻断原因</div>
                              {commandDispatchCheck.blockers.map((item) => <div key={item}>- {item}</div>)}
                            </div>
                          )}
                        </div>
                      )}

                      {renderCommandTaskDetailCard()}

                      <form className="row g-2 align-items-end mt-3" onSubmit={handleApplyCommandTaskFilters}>
                        <div className="col-md-2">
                          <label className="form-label small text-muted">任务状态</label>
                          <select className="form-select form-select-sm" value={commandTaskFilters.status} onChange={(event) => updateCommandTaskFilter("status", event.target.value)} disabled={!canDeviceOps || commandLoading}>
                            <option value="all">全部状态</option>
                            <option value="queued">queued</option>
                            <option value="cancelled">cancelled</option>
                            <option value="sent">sent</option>
                            <option value="failed">failed</option>
                          </select>
                        </div>
                        <div className="col-md-3">
                          <label className="form-label small text-muted">设备号</label>
                          <input className="form-control form-control-sm" value={commandTaskFilters.deviceNo} onChange={(event) => updateCommandTaskFilter("deviceNo", event.target.value)} placeholder="按 deviceNo 模糊查询" disabled={!canDeviceOps || commandLoading} />
                        </div>
                        <div className="col-md-3">
                          <label className="form-label small text-muted">指令类型</label>
                          <select className="form-select form-select-sm" value={commandTaskFilters.commandType} onChange={(event) => updateCommandTaskFilter("commandType", event.target.value)} disabled={!canDeviceOps || commandLoading}>
                            <option value="all">全部类型</option>
                            {availableCommandTemplates.map((item) => (
                              <option key={item.commandType} value={item.commandType}>{item.commandType}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-4">
                          <div className="d-flex gap-2">
                            <button className="btn btn-sm btn-outline-primary flex-fill" type="submit" disabled={!canDeviceOps || commandLoading}>{commandLoading ? "查询中..." : "查询任务"}</button>
                            <button className="btn btn-sm btn-outline-warning flex-fill" type="button" onClick={handleOnlyQueuedCommandTasks} disabled={!canDeviceOps || commandLoading}>只看排队</button>
                            <button className="btn btn-sm btn-outline-secondary flex-fill" type="button" onClick={handleClearCommandTaskFilters} disabled={!canDeviceOps || commandLoading}>清空</button>
                          </div>
                        </div>
                      </form>

                      <div className="table-responsive mt-3">
                        <table className="table table-sm table-hover align-middle">
                          <thead className="table-light">
                            <tr>
                              <th>任务</th>
                              <th>设备</th>
                              <th>指令</th>
                              <th>状态</th>
                              <th>创建时间</th>
                              <th>结果</th>
                              <th>操作</th>
                            </tr>
                          </thead>
                          <tbody>
                            {commandTasks.map((item) => (
                              <tr key={item.taskId || item.id}>
                                <td>#{item.taskId || item.id}</td>
                                <td>
                                  <div>{renderDeviceMonitorLink(item.deviceNo)}</div>
                                  <div className="text-muted small">{item.vehicleNo || "-"}</div>
                                </td>
                                <td>
                                  <div>{item.commandName || item.commandType}</div>
                                  <div className="text-muted small">{item.commandType}</div>
                                </td>
                                <td>{renderCommandStatusBadge(item.status)}</td>
                                <td>{formatDateTime(item.requestedAtUtc)}</td>
                                <td>{item.errorMessage || item.resultMessage || item.remark || "-"}</td>
                                <td>
                                  <button className="btn btn-sm btn-outline-secondary me-2" type="button" onClick={() => handleLoadCommandTaskDetail(item)} disabled={loadingCommandDetailId === String(item.taskId || item.id)}>
                                    {loadingCommandDetailId === String(item.taskId || item.id) ? "加载中..." : "详情"}
                                  </button>
                                  {canCancelCommandTask(item.status) && canOperateCommandTask(item) && (
                                    <button className="btn btn-sm btn-outline-primary me-2" type="button" onClick={() => handleCheckCommandDispatch(item)} disabled={checkingCommandId === String(item.taskId || item.id)}>
                                      {checkingCommandId === String(item.taskId || item.id) ? "检查中..." : "发送检查"}
                                    </button>
                                  )}
                                  {canCancelCommandTask(item.status) && canOperateCommandTask(item) ? (
                                    <button className="btn btn-sm btn-outline-danger" type="button" onClick={() => handleCancelCommandTask(item)} disabled={cancellingCommandId === String(item.taskId || item.id)}>
                                      {cancellingCommandId === String(item.taskId || item.id) ? "取消中..." : "取消"}
                                    </button>
                                  ) : (
                                    <span className="text-muted small">-</span>
                                  )}
                                </td>
                              </tr>
                            ))}
                            {!commandLoading && commandTasks.length === 0 && (
                              <tr>
                                <td colSpan={7}>
                                  <div className="status-banner empty m-0">暂无设备指令任务</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      <div className="d-flex justify-content-between align-items-center mt-2 flex-wrap gap-2">
                        <div className="text-muted small">
                          共 {commandTaskTotal} 条，当前第 {commandTaskPage} / {commandTaskTotalPages} 页
                        </div>
                        <div className="btn-group btn-group-sm">
                          <button className="btn btn-outline-secondary" type="button" disabled={commandLoading || commandTaskPage <= 1} onClick={() => changeCommandTaskPage(commandTaskPage - 1)}>上一页</button>
                          <button className="btn btn-outline-secondary" type="button" disabled={commandLoading || commandTaskPage >= commandTaskTotalPages} onClick={() => changeCommandTaskPage(commandTaskPage + 1)}>下一页</button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          )}

          {showFirmware && (
            <>
          <div className="card border-0 shadow-sm mt-4">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <div className="fw-bold">固件升级任务</div>
                  <div className="text-muted small">当前阶段只登记升级任务和审计，不上传固件、不读取文件、不真实升级设备。</div>
                </div>
                <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => loadFirmwareTasks()} disabled={!canFirmwareUpgrade || firmwareLoading}>
                  {firmwareLoading ? "加载中..." : "刷新升级任务"}
                </button>
              </div>

              {!canFirmwareUpgrade && noPermissionBlock("固件升级任务")}

              <form className="row g-2 align-items-end mb-3" onSubmit={handleApplyFirmwareTaskFilters}>
                <div className="col-md-2">
                  <label className="form-label small text-muted">任务状态</label>
                  <select
                    className="form-select form-select-sm"
                    value={firmwareTaskFilters.status}
                    onChange={(event) => updateFirmwareTaskFilter("status", event.target.value)}
                    disabled={!canFirmwareUpgrade || firmwareLoading}
                  >
                    <option value="all">全部状态</option>
                    <option value="queued">queued</option>
                    <option value="cancelled">cancelled</option>
                    <option value="sent">sent</option>
                    <option value="failed">failed</option>
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label small text-muted">设备号</label>
                  <input
                    className="form-control form-control-sm"
                    value={firmwareTaskFilters.deviceNo}
                    onChange={(event) => updateFirmwareTaskFilter("deviceNo", event.target.value)}
                    placeholder="按 deviceNo 模糊查询"
                    disabled={!canFirmwareUpgrade || firmwareLoading}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label small text-muted">固件版本</label>
                  <input
                    className="form-control form-control-sm"
                    value={firmwareTaskFilters.firmwareVersion}
                    onChange={(event) => updateFirmwareTaskFilter("firmwareVersion", event.target.value)}
                    placeholder="精确匹配版本号"
                    disabled={!canFirmwareUpgrade || firmwareLoading}
                  />
                </div>
                <div className="col-md-4">
                  <div className="d-flex gap-2">
                    <button className="btn btn-sm btn-outline-primary flex-fill" type="submit" disabled={!canFirmwareUpgrade || firmwareLoading}>
                      {firmwareLoading ? "查询中..." : "查询任务"}
                    </button>
                    <button className="btn btn-sm btn-outline-warning flex-fill" type="button" onClick={handleOnlyQueuedFirmwareTasks} disabled={!canFirmwareUpgrade || firmwareLoading}>
                      只看排队
                    </button>
                    <button className="btn btn-sm btn-outline-secondary flex-fill" type="button" onClick={handleClearFirmwareTaskFilters} disabled={!canFirmwareUpgrade || firmwareLoading}>
                      清空
                    </button>
                  </div>
                </div>
              </form>

              <form className="row g-2 align-items-end" onSubmit={handleSubmitFirmwareTask}>
                <div className="col-md-2">
                  <label className="form-label small text-muted">设备号</label>
                  <input
                    className="form-control form-control-sm"
                    value={firmwareForm.deviceNo}
                    onChange={(event) => setFirmwareForm((current) => ({ ...current, deviceNo: event.target.value }))}
                    placeholder="输入 deviceNo"
                    required
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label small text-muted">目标版本</label>
                  <input
                    className="form-control form-control-sm"
                    value={firmwareForm.firmwareVersion}
                    onChange={(event) => setFirmwareForm((current) => ({ ...current, firmwareVersion: event.target.value }))}
                    placeholder="如 V2.1.0"
                    required
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label small text-muted">固件包名称</label>
                  <input
                    className="form-control form-control-sm"
                    value={firmwareForm.packageName}
                    onChange={(event) => setFirmwareForm((current) => ({ ...current, packageName: event.target.value }))}
                    placeholder="登记名称"
                    required
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label small text-muted">文件名</label>
                  <input
                    className="form-control form-control-sm"
                    value={firmwareForm.packageFileName}
                    onChange={(event) => setFirmwareForm((current) => ({ ...current, packageFileName: event.target.value }))}
                    placeholder="可选，仅登记不读取"
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label small text-muted">校验值</label>
                  <input
                    className="form-control form-control-sm"
                    value={firmwareForm.packageChecksum}
                    onChange={(event) => setFirmwareForm((current) => ({ ...current, packageChecksum: event.target.value }))}
                    placeholder="必填 SHA256/MD5"
                    required
                  />
                </div>
                <div className="col-md-10">
                  <input
                    className="form-control form-control-sm"
                    value={firmwareForm.remark}
                    onChange={(event) => setFirmwareForm((current) => ({ ...current, remark: event.target.value }))}
                    placeholder="备注，可选"
                  />
                </div>
                <div className="col-md-2">
                  <button className="btn btn-sm btn-warning w-100" type="submit" disabled={!canFirmwareUpgrade || creatingFirmwareTask || firmwareLoading}>
                    {creatingFirmwareTask ? "创建中..." : "创建升级任务"}
                  </button>
                </div>
              </form>

              {firmwareDispatchCheck && (
                <div className="status-banner warning mt-3">
                  <div className="d-flex flex-wrap justify-content-between gap-2">
                    <div>
                      <div className="fw-bold">固件升级执行检查结果</div>
                      <div className="small text-muted">
                        任务：#{firmwareDispatchCheck.taskId}，
                        设备：{firmwareDispatchCheck.deviceNo}，
                        版本：{firmwareDispatchCheck.firmwareVersion}
                      </div>
                    </div>
                    <div>
                      <span className={firmwareDispatchCheck.checkStatus === "ready" ? "badge bg-success me-2" : "badge bg-warning text-dark me-2"}>
                        {firmwareDispatchCheck.checkStatus || "blocked"}
                      </span>
                      <span className={firmwareDispatchCheck.upgradeEnabled ? "badge bg-success me-2" : "badge bg-secondary me-2"}>
                        开关：{firmwareDispatchCheck.upgradeEnabled ? "已开启" : "关闭"}
                      </span>
                      <span className={firmwareDispatchCheck.deviceOnline ? "badge bg-success me-2" : "badge bg-secondary me-2"}>
                        设备：{firmwareDispatchCheck.deviceOnline ? "在线" : "未在线"}
                      </span>
                      <span className={firmwareDispatchCheck.packageRegistered ? "badge bg-success" : "badge bg-secondary"}>
                        固件包：{firmwareDispatchCheck.packageRegistered ? "已匹配" : "未匹配"}
                      </span>
                    </div>
                  </div>
                  <div className="mt-2 small">
                    固件包：{firmwareDispatchCheck.packageName || "-"}，
                    文件名：{firmwareDispatchCheck.packageFileName || "-"}，
                    校验值：{firmwareDispatchCheck.packageChecksumPresent ? "已登记" : "缺失"}
                  </div>
                  {Array.isArray(firmwareDispatchCheck.blockers) && firmwareDispatchCheck.blockers.length > 0 && (
                    <div className="mt-2">
                      <div className="fw-bold small">阻断原因</div>
                      {firmwareDispatchCheck.blockers.map((item) => (
                        <div key={item}>- {item}</div>
                      ))}
                    </div>
                  )}
                  {Array.isArray(firmwareDispatchCheck.warnings) && firmwareDispatchCheck.warnings.length > 0 && (
                    <div className="mt-2">
                      <div className="fw-bold small">风险提示</div>
                      {firmwareDispatchCheck.warnings.map((item) => (
                        <div key={item}>- {item}</div>
                      ))}
                    </div>
                  )}
                  {Array.isArray(firmwareDispatchCheck.notes) && firmwareDispatchCheck.notes.length > 0 && (
                    <div className="mt-2 text-muted">
                      {firmwareDispatchCheck.notes.map((item) => (
                        <div key={item}>- {item}</div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {renderFirmwareTaskDetailCard()}

              <div className="table-responsive mt-3">
                <table className="table table-sm table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>任务</th>
                      <th>设备</th>
                      <th>固件</th>
                      <th>状态</th>
                      <th>进度</th>
                      <th>创建时间</th>
                      <th>结果</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    {firmwareTasks.map((item) => (
                      <tr key={item.taskId || item.id}>
                        <td>#{item.taskId || item.id}</td>
                        <td>
                          <div>{renderDeviceMonitorLink(item.deviceNo)}</div>
                          <div className="text-muted small">{item.vehicleNo || "-"}</div>
                        </td>
                        <td>
                          <div>{item.firmwareVersion}</div>
                          <div className="text-muted small">{item.packageName}</div>
                          {item.packageFileName && <div className="text-muted small">{item.packageFileName}</div>}
                        </td>
                        <td>{renderCommandStatusBadge(item.status)}</td>
                        <td>{item.progress ?? 0}%</td>
                        <td>{formatDateTime(item.requestedAtUtc)}</td>
                        <td>{item.errorMessage || item.resultMessage || item.remark || "-"}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-secondary me-2"
                            type="button"
                            onClick={() => handleLoadFirmwareTaskDetail(item)}
                            disabled={loadingFirmwareDetailId === String(item.taskId || item.id)}
                          >
                            {loadingFirmwareDetailId === String(item.taskId || item.id) ? "加载中..." : "详情"}
                          </button>
                          {canCancelCommandTask(item.status) && canFirmwareUpgrade && (
                            <button
                              className="btn btn-sm btn-outline-primary me-2"
                              type="button"
                              onClick={() => handleCheckFirmwareDispatch(item)}
                              disabled={checkingFirmwareId === String(item.taskId || item.id)}
                            >
                              {checkingFirmwareId === String(item.taskId || item.id) ? "检查中..." : "执行检查"}
                            </button>
                          )}
                          {canCancelCommandTask(item.status) ? (
                            <button
                              className="btn btn-sm btn-outline-danger"
                              type="button"
                              onClick={() => handleCancelFirmwareTask(item)}
                              disabled={cancellingFirmwareId === String(item.taskId || item.id)}
                            >
                              {cancellingFirmwareId === String(item.taskId || item.id) ? "取消中..." : "取消"}
                            </button>
                          ) : (
                            <span className="text-muted small">-</span>
                          )}
                        </td>
                      </tr>
                    ))}
                    {!firmwareLoading && firmwareTasks.length === 0 && (
                      <tr>
                        <td colSpan={8}>
                          <div className="status-banner empty m-0">暂无固件升级任务</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="card border-0 shadow-sm mt-4">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <div className="fw-bold">固件包登记</div>
                  <div className="text-muted small">只登记固件包元数据，不上传文件、不读取磁盘。</div>
                </div>
                <button className="btn btn-sm btn-outline-secondary" type="button" onClick={loadFirmwarePackages} disabled={!canFirmwareUpgrade || firmwarePackageLoading}>
                  {firmwarePackageLoading ? "加载中..." : "刷新固件包"}
                </button>
              </div>

              {!canFirmwareUpgrade && noPermissionBlock("固件包登记")}

              <form className="row g-2 align-items-end" onSubmit={handleCreateFirmwarePackage}>
                <div className="col-md-2">
                  <label className="form-label small text-muted">版本</label>
                  <input className="form-control form-control-sm" value={firmwarePackageForm.firmwareVersion} onChange={(event) => setFirmwarePackageForm((current) => ({ ...current, firmwareVersion: event.target.value }))} required />
                </div>
                <div className="col-md-2">
                  <label className="form-label small text-muted">包名称</label>
                  <input className="form-control form-control-sm" value={firmwarePackageForm.packageName} onChange={(event) => setFirmwarePackageForm((current) => ({ ...current, packageName: event.target.value }))} required />
                </div>
                <div className="col-md-3">
                  <label className="form-label small text-muted">文件名</label>
                  <input className="form-control form-control-sm" value={firmwarePackageForm.packageFileName} onChange={(event) => setFirmwarePackageForm((current) => ({ ...current, packageFileName: event.target.value }))} placeholder="可选，仅登记" />
                </div>
                <div className="col-md-3">
                  <label className="form-label small text-muted">校验值</label>
                  <input className="form-control form-control-sm" value={firmwarePackageForm.packageChecksum} onChange={(event) => setFirmwarePackageForm((current) => ({ ...current, packageChecksum: event.target.value }))} required />
                </div>
                <div className="col-md-2">
                  <button className="btn btn-sm btn-primary w-100" type="submit" disabled={!canFirmwareUpgrade || creatingFirmwarePackage}>
                    {creatingFirmwarePackage ? "登记中..." : "登记固件包"}
                  </button>
                </div>
                <div className="col-12">
                  <input className="form-control form-control-sm" value={firmwarePackageForm.remark} onChange={(event) => setFirmwarePackageForm((current) => ({ ...current, remark: event.target.value }))} placeholder="备注，可选" />
                </div>
              </form>

              <div className="table-responsive mt-3">
                <table className="table table-sm table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>版本</th>
                      <th>固件包</th>
                      <th>校验值</th>
                      <th>状态</th>
                      <th>登记时间</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    {firmwarePackages.map((item) => (
                      <tr key={item.id}>
                        <td>{item.firmwareVersion}</td>
                        <td>
                          <div>{item.packageName}</div>
                          <div className="text-muted small">{item.packageFileName || "-"}</div>
                        </td>
                        <td><code>{item.packageChecksum}</code></td>
                        <td>{renderStatusBadge(item.status)}</td>
                        <td>{formatDateTime(item.registeredAtUtc)}</td>
                        <td>
                          <button className="btn btn-sm btn-outline-primary me-2" type="button" onClick={() => applyFirmwarePackageToTask(item)} disabled={!canFirmwareUpgrade}>
                            用于升级任务
                          </button>
                          {item.status === "active" ? (
                            <button className="btn btn-sm btn-outline-danger" type="button" onClick={() => handleDisableFirmwarePackage(item)} disabled={!canFirmwareUpgrade || disablingFirmwarePackageId === String(item.id)}>
                              {disablingFirmwarePackageId === String(item.id) ? "停用中..." : "停用"}
                            </button>
                          ) : (
                            <span className="text-muted small">-</span>
                          )}
                        </td>
                      </tr>
                    ))}
                    {!firmwarePackageLoading && firmwarePackages.length === 0 && (
                      <tr>
                        <td colSpan={6}>
                          <div className="status-banner empty m-0">暂无固件包登记</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

            </>
          )}

          {showConfig && (
            <>
          <div className="card border-0 shadow-sm mt-4">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <div className="fw-bold">系统报警规则</div>
                  <div className="text-muted small">轻量规则配置：启用/停用和级别调整，保存后影响派生报警生成。</div>
                </div>
                <button className="btn btn-sm btn-outline-secondary" type="button" onClick={loadSystemAlarmRules} disabled={!canAlarmConfig || ruleLoading}>
                  {ruleLoading ? "加载中..." : "刷新规则"}
                </button>
              </div>

              {!canAlarmConfig && noPermissionBlock("系统报警规则配置")}

              <div className="table-responsive">
                <table className="table table-sm table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>规则</th>
                      <th>级别</th>
                      <th>启用</th>
                      <th>条件</th>
                      <th>更新时间</th>
                    </tr>
                  </thead>
                  <tbody>
                    {systemAlarmRules.map((rule) => (
                      <tr key={rule.ruleKey}>
                        <td>
                          <div className="fw-bold">{rule.name}</div>
                          <div className="text-muted small">{rule.ruleKey}</div>
                          {rule.description && <div className="text-muted small">{rule.description}</div>}
                        </td>
                        <td>
                          <select
                            className="form-select form-select-sm"
                            value={rule.level}
                            onChange={(event) => handleUpdateAlarmRule(rule, { level: event.target.value })}
                            disabled={!canAlarmConfig || updatingRuleKey === rule.ruleKey}
                          >
                            <option value="info">info</option>
                            <option value="warning">warning</option>
                            <option value="critical">critical</option>
                          </select>
                        </td>
                        <td>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={!!rule.isEnabled}
                              onChange={(event) => handleUpdateAlarmRule(rule, { isEnabled: event.target.checked })}
                              disabled={!canAlarmConfig || updatingRuleKey === rule.ruleKey}
                            />
                          </div>
                        </td>
                        <td><code>{rule.conditionJson || "-"}</code></td>
                        <td>{formatDateTime(rule.updatedAtUtc)}</td>
                      </tr>
                    ))}
                    {!ruleLoading && systemAlarmRules.length === 0 && (
                      <tr>
                        <td colSpan={5}>
                          <div className="status-banner empty m-0">暂无系统报警规则</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="card border-0 shadow-sm mt-4">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <div className="fw-bold">程序配置</div>
                  <div className="text-muted small">轻量运行开关与策略配置。敏感配置不会在页面回显或直接修改。</div>
                </div>
                <button className="btn btn-sm btn-outline-secondary" type="button" onClick={loadProgramConfigs} disabled={!canProgramConfig || configLoading}>
                  {configLoading ? "加载中..." : "刷新配置"}
                </button>
              </div>

              {!canProgramConfig && noPermissionBlock("程序配置")}

              <div className="table-responsive">
                <table className="table table-sm table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>配置</th>
                      <th>值</th>
                      <th>类型</th>
                      <th>更新时间</th>
                    </tr>
                  </thead>
                  <tbody>
                    {programConfigs.map((config) => (
                      <tr key={config.configKey}>
                        <td>
                          <div className="fw-bold">{config.displayName}</div>
                          <div className="text-muted small">{config.configKey}</div>
                          {config.description && <div className="text-muted small">{config.description}</div>}
                        </td>
                        <td>
                          {config.isSensitive ? (
                            <span className="text-muted small">敏感配置已隐藏</span>
                          ) : config.valueType === "boolean" ? (
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={(config.configValue || "").toLowerCase() === "true"}
                                onChange={(event) => handleUpdateProgramConfig(config, event.target.checked ? "true" : "false")}
                                disabled={!canProgramConfig || updatingConfigKey === config.configKey}
                              />
                            </div>
                          ) : config.configKey === "redis_online_counter_strategy" ? (
                            <select
                              className="form-select form-select-sm"
                              value={config.configValue || "memory_sample_only"}
                              onChange={(event) => handleUpdateProgramConfig(config, event.target.value)}
                              disabled={!canProgramConfig || updatingConfigKey === config.configKey}
                            >
                              <option value="memory_sample_only">memory_sample_only</option>
                              <option value="database_state">database_state</option>
                              <option value="redis_keys">redis_keys</option>
                            </select>
                          ) : (
                            <input
                              className="form-control form-control-sm"
                              value={config.configValue || ""}
                              onChange={(event) => {
                                const nextValue = event.target.value;
                                setProgramConfigs((current) =>
                                  current.map((item) =>
                                    item.configKey === config.configKey ? { ...item, configValue: nextValue } : item
                                  )
                                );
                              }}
                              onBlur={(event) => handleUpdateProgramConfig(config, event.target.value)}
                              disabled={!canProgramConfig || updatingConfigKey === config.configKey}
                            />
                          )}
                        </td>
                        <td>
                          <span className="badge bg-light text-dark border">{config.valueType || "string"}</span>
                        </td>
                        <td>{formatDateTime(config.updatedAtUtc)}</td>
                      </tr>
                    ))}
                    {!configLoading && programConfigs.length === 0 && (
                      <tr>
                        <td colSpan={4}>
                          <div className="status-banner empty m-0">暂无程序配置</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

            </>
          )}

          {showAlarms && (
            <>
          <form className="row g-2 align-items-end mt-4" onSubmit={handleApplyAlarmFilters}>
            <div className="col-md-2">
              <label className="form-label small text-muted">报警状态</label>
              <select
                className="form-select form-select-sm"
                value={alarmFilters.status}
                onChange={(event) => updateAlarmFilter("status", event.target.value)}
                disabled={!canAlarmView || alarmLoading}
              >
                <option value="all">全部状态</option>
                <option value="active">未处理 active</option>
                <option value="acked">已确认 acked</option>
                <option value="cleared">已清除 cleared</option>
              </select>
            </div>
            <div className="col-md-2">
              <label className="form-label small text-muted">报警级别</label>
              <select
                className="form-select form-select-sm"
                value={alarmFilters.level}
                onChange={(event) => updateAlarmFilter("level", event.target.value)}
                disabled={!canAlarmView || alarmLoading}
              >
                <option value="all">全部级别</option>
                <option value="critical">critical</option>
                <option value="warning">warning</option>
                <option value="info">info</option>
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label small text-muted">关键字</label>
              <input
                className="form-control form-control-sm"
                value={alarmFilters.keyword}
                onChange={(event) => updateAlarmFilter("keyword", event.target.value)}
                placeholder="名称、来源、详情"
                disabled={!canAlarmView || alarmLoading}
              />
            </div>
            <div className="col-md-4">
              <div className="d-flex gap-2">
                <button className="btn btn-sm btn-outline-primary flex-fill" type="submit" disabled={!canAlarmView || alarmLoading}>
                  {alarmLoading ? "查询中..." : "查询报警"}
                </button>
                <button className="btn btn-sm btn-outline-danger flex-fill" type="button" onClick={handleOnlyActiveAlarms} disabled={!canAlarmView || alarmLoading}>
                  只看未处理
                </button>
                <button className="btn btn-sm btn-outline-secondary flex-fill" type="button" onClick={handleClearAlarmFilters} disabled={!canAlarmView || alarmLoading}>
                  清空
                </button>
              </div>
            </div>
          </form>

          {renderAlarmTreatmentRecordsCard()}

          <div className="table-responsive mt-3">
            <table className="table table-sm table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>系统报警</th>
                  <th>级别</th>
                  <th>状态</th>
                  <th>来源</th>
                  <th>最近发现</th>
                  <th>确认信息</th>
                  <th>详情</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                {systemAlarms.map((item) => (
                  <tr key={item.eventId || item.id}>
                    <td>
                      <div className="fw-bold">{item.name}</div>
                      <div className="text-muted small">{item.alarmKey || item.code}</div>
                    </td>
                    <td>{renderAlarmBadge(item.level)}</td>
                    <td>{renderAlarmStatusBadge(item.status)}</td>
                    <td>{item.source || "-"}</td>
                    <td>{formatDateTime(item.lastSeenAtUtc || item.generatedAtUtc)}</td>
                    <td>{renderAlarmTreatmentInfo(item)}</td>
                    <td>{renderAlarmDetail(item)}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-outline-secondary me-2"
                        type="button"
                        onClick={() => handleLoadAlarmTreatmentRecords(item)}
                        disabled={!canAlarmView || loadingAlarmTreatmentId === String(item.eventId || item.id)}
                      >
                        {loadingAlarmTreatmentId === String(item.eventId || item.id) ? "加载中..." : "处理记录"}
                      </button>
                      {item.status === "active" ? (
                        <button
                          className="btn btn-sm btn-outline-primary"
                          type="button"
                          onClick={() => openAckAlarmModal(item)}
                          disabled={!canAlarmView || acknowledgingId === String(item.eventId || item.id)}
                        >
                          {acknowledgingId === String(item.eventId || item.id) ? "确认中..." : "确认"}
                        </button>
                      ) : (
                        <span className="text-muted small">-</span>
                      )}
                    </td>
                  </tr>
                ))}
                {!alarmLoading && systemAlarms.length === 0 && (
                  <tr>
                    <td colSpan={8}>
                      <div className="status-banner empty m-0">暂无系统报警</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
            </>
          )}

          {showServices && (
            <>

          {!canServiceView && noPermissionBlock("服务模块状态")}
          <div className="d-flex justify-content-between align-items-center mt-4 mb-2">
            <div>
              <div className="fw-bold">服务模块状态</div>
              <div className="text-muted small">主动检查只记录当前快照和审计，不执行服务重启或远程控制。</div>
            </div>
            <button
              className="btn btn-sm btn-outline-primary"
              type="button"
              onClick={handleCheckServiceStatuses}
              disabled={!canServiceManage || checkingServices}
            >
              {checkingServices ? "检查中..." : "主动检查"}
            </button>
          </div>
          {!canServiceManage && <div className="status-banner warn mt-2">当前账号无服务主动检查权限。</div>}
          {serviceStatusCheck && (
            <div className={serviceStatusCheck.abnormalCount > 0 ? "status-banner warn mt-2" : "status-banner info mt-2"}>
              <div className="fw-bold">
                服务检查结果：{serviceStatusCheck.checkStatus || "-"}，异常 {serviceStatusCheck.abnormalCount ?? 0} / {serviceStatusCheck.totalCount ?? 0}
              </div>
              <div className="small text-muted">检查时间：{formatDateTime(serviceStatusCheck.checkedAtUtc)}</div>
              {Array.isArray(serviceStatusCheck.abnormalServices) && serviceStatusCheck.abnormalServices.length > 0 && (
                <div className="mt-2">
                  {serviceStatusCheck.abnormalServices.map((item) => (
                    <div key={item.key}>- {item.name || item.key}：{item.status || "-"}，{item.detail || "-"}</div>
                  ))}
                </div>
              )}
              {Array.isArray(serviceStatusCheck.warnings) && serviceStatusCheck.warnings.map((item) => (
                <div key={item}>- {item}</div>
              ))}
              {Array.isArray(serviceStatusCheck.notes) && serviceStatusCheck.notes.map((item) => (
                <div className="text-muted" key={item}>- {item}</div>
              ))}
            </div>
          )}
          <div className="table-responsive mt-4">
            <table className="table table-sm table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>服务模块</th>
                  <th>状态</th>
                  <th>来源</th>
                  <th>类型/IP</th>
                  <th>最后心跳</th>
                  <th>详情</th>
                </tr>
              </thead>
              <tbody>
                {services.map((item) => (
                  <tr key={item.key}>
                    <td>
                      <div>{item.name}</div>
                      <div className="text-muted small">{item.key}</div>
                    </td>
                    <td>{renderStatusBadge(item.status)}</td>
                    <td><span className="badge bg-light text-dark border">{item.source || "runtime"}</span></td>
                    <td>
                      <div>{item.moduleType || "-"}</div>
                      <div className="text-muted small">{item.ipAddress || "-"}</div>
                    </td>
                    <td>{formatDateTime(item.lastHeartbeatUtc)}</td>
                    <td>
                      <div>{item.detail}</div>
                      {item.statusInfoJson && <code className="d-block text-wrap small">{item.statusInfoJson}</code>}
                    </td>
                  </tr>
                ))}
                {!loading && services.length === 0 && (
                  <tr>
                    <td colSpan={6}>
                      <div className="status-banner empty m-0">暂无服务状态</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
            </>
          )}

          {showLogs && (
          <div className="card border-0 shadow-sm mt-4">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <div className="fw-bold">操作审计日志</div>
                  <div className="text-muted small">最近 20 条 GGGManager 操作记录，来源于系统操作日志。</div>
                </div>
                <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => loadOperationLogs()} disabled={logLoading}>
                  {logLoading ? "加载中..." : "刷新日志"}
                </button>
              </div>

              <form className="row g-2 align-items-end mb-3" onSubmit={handleApplyLogFilters}>
                <div className="col-md-4">
                  <label className="form-label small text-muted">操作类型</label>
                  <select
                    className="form-select form-select-sm"
                    value={logFilters.opType}
                    onChange={(event) => updateLogFilter("opType", event.target.value)}
                    disabled={logLoading}
                  >
                    <option value="">全部类型</option>
                    {gggOperationLogTypes.map((type) => (
                      <option key={type} value={type}>{type}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-5">
                  <label className="form-label small text-muted">关键字</label>
                  <input
                    className="form-control form-control-sm"
                    value={logFilters.keyword}
                    onChange={(event) => updateLogFilter("keyword", event.target.value)}
                    placeholder="类型、用户、详情"
                    disabled={logLoading}
                  />
                </div>
                <div className="col-md-3">
                  <div className="d-flex gap-2">
                    <button className="btn btn-sm btn-outline-primary flex-fill" type="submit" disabled={logLoading}>
                      {logLoading ? "查询中..." : "查询"}
                    </button>
                    <button className="btn btn-sm btn-outline-secondary flex-fill" type="button" onClick={handleClearLogFilters} disabled={logLoading}>
                      清空
                    </button>
                  </div>
                </div>
              </form>

              <div className="table-responsive">
                <table className="table table-sm table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>时间</th>
                      <th>用户</th>
                      <th>类型</th>
                      <th>详情</th>
                    </tr>
                  </thead>
                  <tbody>
                    {operationLogs.map((item) => (
                      <tr key={item.id}>
                        <td>{formatDateTime(item.opTimeUtc)}</td>
                        <td>{item.userId || "-"}</td>
                        <td><span className="badge bg-light text-dark border">{item.opType || "-"}</span></td>
                        <td>{renderOperationLogDetail(item.detail)}</td>
                      </tr>
                    ))}
                    {!logLoading && operationLogs.length === 0 && (
                      <tr>
                        <td colSpan={4}>
                          <div className="status-banner empty m-0">暂无 GGGManager 操作审计日志</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          )}

          {showOverview && (
          <div className="table-responsive mt-4">
            <table className="table table-sm table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>能力模块</th>
                  <th>说明</th>
                  <th>状态</th>
                </tr>
              </thead>
              <tbody>
                {capabilities.map((item) => (
                  <tr key={item.key}>
                    <td>{item.key}</td>
                    <td>{item.name}</td>
                    <td>
                      {renderStatusBadge(item.status)}
                    </td>
                  </tr>
                ))}
                {!loading && capabilities.length === 0 && (
                  <tr>
                    <td colSpan={3}>
                      <div className="status-banner empty m-0">暂无 GGGManager 能力配置</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          )}
        </div>
      </div>

      <ActionModal
        open={commandModal.open}
        title={commandModal.action ? commandModal.action.label : "设备指令"}
        message={commandModal.device ? `设备：${commandModal.device.vehicleNo || "-"} / ${commandModal.device.deviceNo || "-"}` : ""}
        fields={getCommandModalFields(commandModal.action)}
        initialValues={getCommandModalInitialValues(commandModal.action)}
        confirmText={
          sendingCommand
            ? "处理中..."
            : commandModal.device?.runtimeOnline
              ? "执行并等待返回"
              : "创建离线任务"
        }
        confirmClassName={commandModal.action?.kind === "read" ? "btn-primary" : "btn-danger"}
        submitting={sendingCommand}
        onCancel={closeCommandModal}
        onConfirm={submitCommandModal}
      >
        {commandModal.device && (
          <div className="d-flex flex-wrap gap-2 mb-3">
            {renderDeviceOnlineBadge(commandModal.device)}
            <span className="badge bg-light text-dark border">客户：{commandModal.device.customerName || "-"}</span>
            <span className="badge bg-light text-dark border">分组：{commandModal.device.groupName || "-"}</span>
          </div>
        )}
        {commandModal.action?.kind === "read" && (
          <div className="status-banner info mb-3">
            点击执行后，在线设备会等待返回并在这里展示读出的参数；离线设备会创建任务。
          </div>
        )}
        {commandModal.action?.kind === "action" && (
          <div className="status-banner warn mb-3">
            该操作会影响设备运行状态，请确认目标设备无误。
          </div>
        )}
        {commandModal.result && (
          <div className={commandModal.result.status === "failed" ? "status-banner warning mt-3" : "status-banner success mt-3"}>
            <div className="d-flex flex-wrap justify-content-between gap-2">
              <div>
                <div className="fw-bold">{commandModal.result.queuedOnly ? "已创建离线任务" : "执行结果"}</div>
                <div className="small">任务：#{commandModal.result.taskId || "-"}，状态：{commandModal.result.status || "-"}</div>
              </div>
              {commandModal.result.responseProtocolName && (
                <span className="badge bg-success align-self-start">{commandModal.result.responseProtocolName}</span>
              )}
            </div>
            <div className="mt-2">{commandModal.result.message || "-"}</div>
            {commandModal.result.responsePayload && (
              <div className="mt-3">
                <div className="fw-bold small mb-2">返回参数</div>
                {renderCommandResultPayload(commandModal.result.responsePayload)}
              </div>
            )}
          </div>
        )}
      </ActionModal>

      <ActionModal
        open={ackAlarmModal.open}
        title="确认系统报警"
        message={ackAlarmModal.row ? `报警：${ackAlarmModal.row.name || ackAlarmModal.row.alarmKey || "-"}` : ""}
        fields={[
          {
            name: "remark",
            label: "处置备注",
            placeholder: "填写确认原因或处置说明，可留空",
            hint: "备注会写入系统报警事件，并随确认操作进入审计日志。"
          }
        ]}
        initialValues={{ remark: "" }}
        confirmText="确认报警"
        confirmClassName="btn-primary"
        submitting={!!acknowledgingId}
        onCancel={() => setAckAlarmModal({ open: false, row: null })}
        onConfirm={submitAckAlarm}
      />
    </div>
  );
}










